
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("dACnQ", function(module, exports) {
$parcel$export(module.exports, "LayoutHeader", () => (parcelRequire("e0Kny")).default);

var $e0Kny = parcelRequire("e0Kny");

});
parcelRegister("e0Kny", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b8ce868169bfa26$export$2e2bcd8739ae039);

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $1xrTy = parcelRequire("1xrTy");

var $6GvED = parcelRequire("6GvED");

var $edKNU = parcelRequire("edKNU");

var $38uh5 = parcelRequire("38uh5");

var $hA56G = parcelRequire("hA56G");

var $aI0YR = parcelRequire("aI0YR");

var $hGqAv = parcelRequire("hGqAv");

var $oORS9 = parcelRequire("oORS9");

var $aUL93 = parcelRequire("aUL93");
const $8b8ce868169bfa26$var$getHeaderLoginUrl = (state)=>{
    const portalId = (0, $1xrTy.getPortalId)(state);
    return (0, $oORS9.getLoginUrl)({
        portalId: portalId,
        isAbsolute: true,
        redirectUrl: (0, $1xrTy.getPathname)(state)
    });
};
const $8b8ce868169bfa26$var$userRequestsSelector = (state)=>{
    return (0, $hGqAv.getUserRequestsCounts)(state);
};
const $8b8ce868169bfa26$var$selector = (0, $BOq7h.createSelector)((0, $aI0YR.isLoggedIn), $8b8ce868169bfa26$var$getHeaderLoginUrl, (0, $aI0YR.isUserLoaded), (0, $38uh5.isCustomizing), $8b8ce868169bfa26$var$userRequestsSelector, (0, $hA56G.getOrganisations), (0, $6GvED.getIsAnonymousEnabled), (0, $edKNU.getHelpCenterTopBarColor), (0, $edKNU.getHelpCenterTopBarSplitFlag), (0, $edKNU.getLogoUrl), (0, $edKNU.getSharedPortalName), (userLoggedIn, loginUrl, userLoaded, customizing, userRequest, organisations, anonymousEnabled, topBarColor, hasTopBarBeenSplit, logoUrl, name)=>({
        hasTopBarBeenSplit: hasTopBarBeenSplit,
        headerProps: {
            userLoggedIn: userLoggedIn,
            loginUrl: loginUrl,
            userRequest: userRequest,
            organisations: organisations,
            anonymousEnabled: anonymousEnabled,
            isUserLoaded: userLoaded,
            isCustomizing: customizing,
            headerBackgroundColor: hasTopBarBeenSplit ? topBarColor : undefined,
            logoUrl: logoUrl ?? undefined,
            name: name ?? undefined
        }
    }));
var $8b8ce868169bfa26$export$2e2bcd8739ae039 = (0, $egQxE.connect)($8b8ce868169bfa26$var$selector, {})((0, $aUL93.LayoutHeader));

});
parcelRegister("aUL93", function(module, exports) {
$parcel$export(module.exports, "LayoutHeader", () => $47dc1d4db0bdada5$export$ea7cf2c7e43b0ee4);

var $5weqX = parcelRequire("5weqX");

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");

var $a2qIF = parcelRequire("a2qIF");

var $gXTTj = parcelRequire("gXTTj");

var $c3QJe = parcelRequire("c3QJe");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");
const $47dc1d4db0bdada5$export$ea7cf2c7e43b0ee4 = (props)=>{
    var _data$subsections, _data$visualConfig;
    const data = (0, $a2qIF.useFragment)((0, $5weqX.default), props.firstSectionFragment);
    const { hasTopBarBeenSplit: hasTopBarBeenSplit } = props;
    const [isPageInEditMode] = (0, $c3QJe.useIsPageInEditMode)();
    const isFirstSectionHero = (data === null || data === void 0 || (_data$subsections = data.subsections) === null || _data$subsections === void 0 || (_data$subsections = _data$subsections[0]) === null || _data$subsections === void 0 || (_data$subsections = _data$subsections.elements) === null || _data$subsections === void 0 || (_data$subsections = _data$subsections[0]) === null || _data$subsections === void 0 ? void 0 : _data$subsections.__typename) === 'HelpLayoutHeroElement';
    const isFirstSectionHidden = Boolean(data === null || data === void 0 || (_data$visualConfig = data.visualConfig) === null || _data$visualConfig === void 0 ? void 0 : _data$visualConfig.hidden);
    const transparentHeader = (0, $bSJIT.useMemo)(()=>{
        if ((0, $lFpPv.isUseHelpCenterRefresh)() && hasTopBarBeenSplit) return false;
        if (isPageInEditMode) return isFirstSectionHero && !isFirstSectionHidden;
        // view HomePage
        return isFirstSectionHero;
    }, [
        hasTopBarBeenSplit,
        isFirstSectionHero,
        isFirstSectionHidden,
        isPageInEditMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: transparentHeader ? $47dc1d4db0bdada5$var$absoluteHeader : $47dc1d4db0bdada5$var$relativeHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gXTTj.DumbHeader), {
        ...props.headerProps,
        isAnonymous: false,
        logoTextColor: "banner",
        hideSearchButton: true,
        showThemedBackground: !transparentHeader,
        disableAllHeaderLinks: isPageInEditMode
    }));
};
const $47dc1d4db0bdada5$var$absoluteHeader = (0, $9BVpB.xcss)({
    position: 'absolute',
    top: 'space.0',
    width: '100%',
    zIndex: 'navigation'
});
const $47dc1d4db0bdada5$var$relativeHeader = (0, $9BVpB.xcss)({
    position: 'relative',
    width: '100%'
});

});
parcelRegister("5weqX", function(module, exports) {
$parcel$export(module.exports, "default", () => $a758a9edd70898f7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b562ef86ec42de8b693ab3903bf313cb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a758a9edd70898f7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "layoutHeaderFragment",
    "selections": [
        {
            "concreteType": "HelpLayoutSubsection",
            "kind": "LinkedField",
            "name": "subsections",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "elements",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "HelpLayoutVisualConfig",
            "kind": "LinkedField",
            "name": "visualConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hidden"
                }
            ]
        }
    ],
    "type": "HelpLayoutSection"
};
$a758a9edd70898f7$var$node.hash = "f703cce131491f9f467281f622f22a23";
var $a758a9edd70898f7$export$2e2bcd8739ae039 = $a758a9edd70898f7$var$node;

});




parcelRegister("3AFAl", function(module, exports) {
$parcel$export(module.exports, "NoContent", () => $7f80f233a3e1b6e4$export$7365296e18286c25);

var $cVM5r = parcelRequire("cVM5r");

var $cJJTb = parcelRequire("cJJTb");

const $7f80f233a3e1b6e4$export$7365296e18286c25 = (0, $cVM5r.default)({
    loader: (0, $cJJTb.lazyForPaint)(()=>(parcelRequire("7DmYh")), {
        moduleId: "./packages/help-center/customisation/elements/no-content/src/ui/no-content.tsx"
    })
});

});
parcelRegister("7DmYh", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("56TlW").then(()=>parcelRequire('4XIDH'));

});
parcelRegister("kOunM", function(module, exports) {
"use strict";

function $f2700b8349aa6afb$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("gBxz7")).resolve(id));
}
module.exports = $f2700b8349aa6afb$var$load;

});
parcelRegister("gBxz7", function(module, exports) {
$parcel$export(module.exports, "register", () => $c16a23763a54f59d$export$6503ec6e8aabbaf, (v) => $c16a23763a54f59d$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $c16a23763a54f59d$export$f7ad0328861e2f03, (v) => $c16a23763a54f59d$export$f7ad0328861e2f03 = v);
var $c16a23763a54f59d$export$6503ec6e8aabbaf;
var $c16a23763a54f59d$export$f7ad0328861e2f03;
"use strict";
var $c16a23763a54f59d$var$mapping = new Map();
function $c16a23763a54f59d$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c16a23763a54f59d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c16a23763a54f59d$var$resolve(id) {
    var resolved = $c16a23763a54f59d$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c16a23763a54f59d$export$6503ec6e8aabbaf = $c16a23763a54f59d$var$register;
$c16a23763a54f59d$export$f7ad0328861e2f03 = $c16a23763a54f59d$var$resolve;

});




parcelRegister("hbgJY", function(module, exports) {
$parcel$export(module.exports, "backgroundStyleFromVisualConfig", () => $87d1bc9ab6309515$export$13596409a6f2e990);
const $87d1bc9ab6309515$export$13596409a6f2e990 = (visualConfig, fallBack)=>{
    var _visualConfig$backgro;
    let backgroundColor;
    let backgroundImageUrl;
    switch(visualConfig === null || visualConfig === void 0 ? void 0 : visualConfig.backgroundType){
        case 'COLOR':
            backgroundColor = visualConfig.backgroundColor || (fallBack === null || fallBack === void 0 ? void 0 : fallBack.backgroundColor) || 'transparent';
            backgroundImageUrl = undefined;
            break;
        case 'IMAGE':
            backgroundColor = visualConfig.backgroundColor || 'transparent';
            backgroundImageUrl = ((_visualConfig$backgro = visualConfig.backgroundImage) === null || _visualConfig$backgro === void 0 ? void 0 : _visualConfig$backgro.url) || (fallBack === null || fallBack === void 0 ? void 0 : fallBack.backgroundImageUrl) || undefined;
            break;
        default:
            backgroundColor = 'transparent';
            backgroundImageUrl = undefined;
            break;
    }
    return {
        backgroundColor: backgroundColor,
        backgroundImage: backgroundImageUrl
    };
};

});

parcelRegister("9QsVF", function(module, exports) {
$parcel$export(module.exports, "useApplySectionBackground", () => $ba8d372c53711a5a$export$efa98f60da2708e5);

var $lFpPv = parcelRequire("lFpPv");
const $ba8d372c53711a5a$export$efa98f60da2708e5 = function({ sectionTypename: sectionTypename }) {
    const allowedSectionBackgroundTypes = [
        'HelpLayoutHeroElement',
        'HelpLayoutAnnouncementElement'
    ];
    if ((0, $lFpPv.isIncreasedFlexibilityEnabled)()) // allowed for all
    return true;
    return allowedSectionBackgroundTypes.includes(sectionTypename);
};

});

parcelRegister("bxT0a", function(module, exports) {
$parcel$export(module.exports, "AlignmentSettingsContext", () => (parcelRequire("h3I9M")).default);
$parcel$export(module.exports, "useAlignmentSettings", () => (parcelRequire("h3I9M")).useAlignmentSettings);

var $h3I9M = parcelRequire("h3I9M");

});
parcelRegister("h3I9M", function(module, exports) {
$parcel$export(module.exports, "useAlignmentSettings", () => $0143c3332b89e136$export$d3209278010f9296);
$parcel$export(module.exports, "default", () => $0143c3332b89e136$export$2e2bcd8739ae039);

var $5nBsk = parcelRequire("5nBsk");

var $dzXVE = parcelRequire("dzXVE");

var $bSJIT = parcelRequire("bSJIT");

var $a2qIF = parcelRequire("a2qIF");
parcelRequire("c68Hs");
var $cdLKz = parcelRequire("cdLKz");
const $0143c3332b89e136$export$6cb3ce7ba59b0743 = /*#__PURE__*/ (0, $bSJIT.createContext)({});
const $0143c3332b89e136$var$AlignmentSettings = ({ visualConfig: visualConfig, children: children })=>{
    var _data$alignment2;
    const data = (0, $a2qIF.useFragment)((0, $dzXVE.default), visualConfig);
    const alignmentSettings = data === null || data === void 0 ? void 0 : data.alignment;
    const parentAlignmentSettings = $0143c3332b89e136$export$12f75a6ba8295240();
    const prevParentAlignmentSettings = (0, $cdLKz.default)(parentAlignmentSettings);
    const environment = (0, $a2qIF.useRelayEnvironment)();
    (0, $bSJIT.useEffect)(()=>{
        if (prevParentAlignmentSettings && prevParentAlignmentSettings.horizontalAlignment && (prevParentAlignmentSettings === null || prevParentAlignmentSettings === void 0 ? void 0 : prevParentAlignmentSettings.horizontalAlignment) !== (parentAlignmentSettings === null || parentAlignmentSettings === void 0 ? void 0 : parentAlignmentSettings.horizontalAlignment)) (0, $a2qIF.commitLocalUpdate)(environment, (store)=>{
            var _data$alignment;
            const id = data === null || data === void 0 || (_data$alignment = data.alignment) === null || _data$alignment === void 0 ? void 0 : _data$alignment.__id;
            if (id) {
                const alignmentRecord = store.get(id);
                if (alignmentRecord) alignmentRecord.setValue(null, 'horizontalAlignment');
            }
        });
    }, [
        data === null || data === void 0 || (_data$alignment2 = data.alignment) === null || _data$alignment2 === void 0 ? void 0 : _data$alignment2.__id,
        environment,
        parentAlignmentSettings === null || parentAlignmentSettings === void 0 ? void 0 : parentAlignmentSettings.horizontalAlignment,
        prevParentAlignmentSettings,
        prevParentAlignmentSettings === null || prevParentAlignmentSettings === void 0 ? void 0 : prevParentAlignmentSettings.horizontalAlignment
    ]);
    if (alignmentSettings) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($0143c3332b89e136$export$6cb3ce7ba59b0743.Provider, {
        value: alignmentSettings
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.only(children));
};
const $0143c3332b89e136$export$12f75a6ba8295240 = ()=>{
    return (0, $bSJIT.useContext)($0143c3332b89e136$export$6cb3ce7ba59b0743);
};
const $0143c3332b89e136$export$d3209278010f9296 = (visualConfig)=>{
    const data = (0, $a2qIF.useFragment)((0, $5nBsk.default), visualConfig);
    const alignment = (data === null || data === void 0 ? void 0 : data.alignment) ?? null;
    return {
        horizontalAlignment: alignment === null || alignment === void 0 ? void 0 : alignment.horizontalAlignment,
        verticalAlignment: alignment === null || alignment === void 0 ? void 0 : alignment.verticalAlignment
    };
};
var $0143c3332b89e136$export$2e2bcd8739ae039 = $0143c3332b89e136$var$AlignmentSettings;

});
parcelRegister("5nBsk", function(module, exports) {
$parcel$export(module.exports, "default", () => $adb067d07788c6c3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4da02b189ad764697b671c487ca4ec62>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $adb067d07788c6c3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "alignmentSettingsContextHookFragment",
    "selections": [
        {
            "concreteType": "HelpLayoutAlignmentSettings",
            "kind": "LinkedField",
            "name": "alignment",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "horizontalAlignment"
                },
                {
                    "kind": "ScalarField",
                    "name": "verticalAlignment"
                },
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__id"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "HelpLayoutVisualConfig"
};
$adb067d07788c6c3$var$node.hash = "39c2c6605fdc2a08a29e64bca508f0ba";
var $adb067d07788c6c3$export$2e2bcd8739ae039 = $adb067d07788c6c3$var$node;

});

parcelRegister("dzXVE", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ac94c8eea11dd21$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1aaeca60e713bd0a1491d57505b4511e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0ac94c8eea11dd21$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "alignmentSettingsContextFragment",
    "selections": [
        {
            "concreteType": "HelpLayoutAlignmentSettings",
            "kind": "LinkedField",
            "name": "alignment",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "horizontalAlignment"
                },
                {
                    "kind": "ScalarField",
                    "name": "verticalAlignment"
                },
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__id"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "HelpLayoutVisualConfig"
};
$0ac94c8eea11dd21$var$node.hash = "e8bd7e9e63e3ee57f31e69ea25b912df";
var $0ac94c8eea11dd21$export$2e2bcd8739ae039 = $0ac94c8eea11dd21$var$node;

});

parcelRegister("c68Hs", function(module, exports) {
$parcel$export(module.exports, "usePreviousValue", () => (parcelRequire("cdLKz")).default);

var $cdLKz = parcelRequire("cdLKz");

});
parcelRegister("cdLKz", function(module, exports) {
$parcel$export(module.exports, "default", () => $58390be36ad60ad5$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
function $58390be36ad60ad5$var$usePreviousValue(value) {
    const ref = (0, $bSJIT.useRef)();
    (0, $bSJIT.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    // Return previous value (happens before update in useEffect above)
    return ref.current;
}
var $58390be36ad60ad5$export$2e2bcd8739ae039 = $58390be36ad60ad5$var$usePreviousValue;

});




parcelRegister("4u8Jv", function(module, exports) {
$parcel$export(module.exports, "HelpCenterAnnouncement", () => (parcelRequire("21Htt")).default);
parcelRequire("1mCp2");
var $21Htt = parcelRequire("21Htt");

});
parcelRegister("1mCp2", function(module, exports) {
$parcel$export(module.exports, "HelpCenterAnnouncement", () => (parcelRequire("21Htt")).default);

var $21Htt = parcelRequire("21Htt");

});
parcelRegister("21Htt", function(module, exports) {
$parcel$export(module.exports, "default", () => $f98224bd749323ce$export$2e2bcd8739ae039);

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $edKNU = parcelRequire("edKNU");

var $6O5xJ = parcelRequire("6O5xJ");
const $f98224bd749323ce$var$selector = (0, $BOq7h.createSelector)((0, $edKNU.getThemeColor), (0, $edKNU.getHelpCenterTopBarSplitFlag), (themeColor, hasTopBarBeenSplit)=>({
        themeColor: themeColor,
        hasTopBarBeenSplit: hasTopBarBeenSplit
    }));
var $f98224bd749323ce$export$2e2bcd8739ae039 = (0, $egQxE.connect)($f98224bd749323ce$var$selector, {})((0, $6O5xJ.HelpCenterAnnouncement));

});
parcelRegister("6O5xJ", function(module, exports) {
$parcel$export(module.exports, "HelpCenterAnnouncement", () => $08d7babb46537a8c$export$b9295283b019bae4);

var $7aI2q = parcelRequire("7aI2q");

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $cwcdv = parcelRequire("cwcdv");

var $lFpPv = parcelRequire("lFpPv");

var $ki6Qt = parcelRequire("ki6Qt");

var $fU62V = parcelRequire("fU62V");

var $a7Tmb = parcelRequire("a7Tmb");

var $9Zwzr = parcelRequire("9Zwzr");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $abU28 = parcelRequire("abU28");

var $busvu = parcelRequire("busvu");

var $cAJ8B = parcelRequire("cAJ8B");

var $c3QJe = parcelRequire("c3QJe");

var $85rmf = parcelRequire("85rmf");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $4pSON = parcelRequire("4pSON");

var $fyqLX = parcelRequire("fyqLX");

var $lumfd = parcelRequire("lumfd");
const $08d7babb46537a8c$export$b9295283b019bae4 = ({ themeColor: themeColor, announcementElement: announcementElement, hasTopBarBeenSplit: hasTopBarBeenSplit })=>{
    const data = (0, $a2qIF.useFragment)((0, $7aI2q.default), announcementElement);
    const [isPageInEditMode] = (0, $c3QJe.useIsPageInEditMode)();
    const [isPageInPreviewMode] = (0, $c3QJe.useIsPageInPreviewMode)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    let backgroundColor = undefined;
    if ((0, $lFpPv.isIncreasedFlexibilityEnabled)()) backgroundColor = (0, $4pSON.lightenHexColor)(themeColor, 0.85) || themeColor; // since lightenHexColor has null return we have themeColor to make non nullable
    const announcement = {
        ...data
    };
    //fallback UI in edit mode
    if (isPageInEditMode && !isPageInPreviewMode && !announcement.header && !announcement.message) {
        const message = (0, $lFpPv.isIncreasedFlexibilityEnabled)() ? (0, $lumfd.default).emptyStateAnnouncementDescription : (0, $lumfd.default).emptyStateDescription;
        return /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
            xcss: $08d7babb46537a8c$var$nonDraggableStyle,
            style: {
                backgroundColor: backgroundColor ?? 'transparent'
            }
        }, /*#__PURE__*/ $bSJIT.createElement((0, $85rmf.default), {
            header: "",
            maxImageWidth: 250,
            description: formatMessage(message, {
                b: (chunks)=>/*#__PURE__*/ $bSJIT.createElement("b", null, chunks)
            }),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($9Zwzr))),
            width: "wide"
        }));
    }
    //Removing all hyperlinks from announcement message when page is in edit mode
    if (isPageInEditMode && !!announcement.message) announcement.message = (0, $fyqLX.removeHyperlinks)(announcement.message);
    if ((0, $lFpPv.isIncreasedFlexibilityEnabled)()) {
        if (!announcement.header && !announcement.message) return null;
        return /*#__PURE__*/ $bSJIT.createElement((0, $abU28.ElementRoot), {
            elementWidth: (0, $abU28.ElementWidth).FULL_WIDTH,
            elementMargins: (0, $busvu.ElementMargins).COMPACT,
            removePadding: true
        }, /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
            testId: 'help-center-announcement-background',
            xcss: hasTopBarBeenSplit ? $08d7babb46537a8c$var$announcementBackgroundContainer : $08d7babb46537a8c$var$announcementBackgroundContainerWithoutTopBarSplit,
            style: {
                backgroundColor: backgroundColor ?? 'transparent'
            }
        }, /*#__PURE__*/ $bSJIT.createElement((0, $cwcdv.default), {
            actionSubjectId: "helpCenterAnnouncementBanner",
            removeBgColor: true,
            header: announcement.header || '',
            messageHtml: announcement.message || '',
            InnerContainerComponent: $08d7babb46537a8c$var$AnnouncementInnerContainer,
            isLayoutInEditMode: isPageInEditMode,
            isLayoutInPreviewMode: isPageInPreviewMode
        })));
    }
    return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, !!announcement && /*#__PURE__*/ $bSJIT.createElement((0, $cwcdv.default), {
        actionSubjectId: "helpCenterAnnouncementBanner",
        removeBgColor: true,
        header: announcement.header || '',
        messageHtml: announcement.message || '',
        InnerContainerComponent: $08d7babb46537a8c$var$AnnouncementInnerContainer,
        isLayoutInEditMode: isPageInEditMode,
        isLayoutInPreviewMode: isPageInPreviewMode
    }));
};
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $08d7babb46537a8c$var$AnnouncementInnerContainer = /*#__PURE__*/ (0, $4v2A7.default)((0, $cAJ8B.PaperContent)).withConfig({
    componentId: "sc-1h1hkk3-0"
})`${$fU62V.borderBox};width:100%;margin:0 auto;padding:0 ${"var(--ds-space-400, 32px)"};${$ki6Qt.fromSmall.css`
    max-width: ${(0, $a7Tmb.sizes).small}px;
    /* We deliberately use padding-right/left so we can override top/bottom easily. */
    padding-right: ${"var(--ds-space-600, 48px)"};
    padding-left: ${"var(--ds-space-600, 48px)"};
`};`;
const $08d7babb46537a8c$var$nonDraggableStyle = (0, $9BVpB.xcss)({
    pointerEvents: 'none'
});
const $08d7babb46537a8c$var$announcementBackgroundContainer = (0, $9BVpB.xcss)({
    width: '100%',
    borderRadius: 'radius.large'
});
const $08d7babb46537a8c$var$announcementBackgroundContainerWithoutTopBarSplit = (0, $9BVpB.xcss)({
    width: '100%'
});

});
parcelRegister("7aI2q", function(module, exports) {
$parcel$export(module.exports, "default", () => $d47f3798597962c5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7b9cde396e6d94d1bfb23ec3f42a15bd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d47f3798597962c5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "helpCenterAnnouncementFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "header"
        },
        {
            "kind": "ScalarField",
            "name": "message"
        }
    ],
    "type": "HelpLayoutAnnouncementElement"
};
$d47f3798597962c5$var$node.hash = "7a1ed4e240ff1dc0c102abd9318b56ae";
var $d47f3798597962c5$export$2e2bcd8739ae039 = $d47f3798597962c5$var$node;

});

parcelRegister("9Zwzr", function(module, exports) {
module.exports = new URL("../images/fallback-announcement.c59df0fb.svg", import.meta.url).toString();

});

parcelRegister("lumfd", function(module, exports) {
$parcel$export(module.exports, "default", () => $345e295d934bb420$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $345e295d934bb420$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    emptyStateDescription: {
        defaultMessage: "You haven't created an announcement yet. To create one, select Announcements from the avatar menu.",
        description: 'Empty state message when announcement has not been created',
        id: 'help.center.announcement.edit.empty.state'
    },
    emptyStateAnnouncementDescription: {
        defaultMessage: "You haven\u2019t created an announcement yet. Select <b>Customize,</b> then <b>Manage announcements</b> from the navigation to create one. ",
        description: 'Empty state message when announcement has not been created',
        id: 'help.center.announcement.edit.empty.state.announcement'
    }
});

});





parcelRegister("3BUo9", function(module, exports) {
$parcel$export(module.exports, "useGetValidHelpCenterAuthProvider", () => $97b7f48454937b52$export$71a7df514f18fa5a);

var $7FKuw = parcelRequire("7FKuw");

var $bSJIT = parcelRequire("bSJIT");

var $4270B = parcelRequire("4270B");

var $3qDrS = parcelRequire("3qDrS");

var $fuVmc = parcelRequire("fuVmc");

var $kbkME = parcelRequire("kbkME");

var $jfKi6 = parcelRequire("jfKi6");
const $97b7f48454937b52$var$MEDIA_TOKEN_EXPIRY_DURATION_IN_MS = 600000; // 10 minutes
const $97b7f48454937b52$var$fetchMediaConfig = async ()=>{
    try {
        var _fetchedData$helpLayo;
        const fetchedData = await (0, $4270B.fetchQuery)((0, $kbkME.getRelayEnvironment)(), (0, $7FKuw.default), {
            helpCenterAri: (0, $fuVmc.getHelpCenterAri)(),
            cloudId: (0, $fuVmc.getCloudId)()
        }, {
            fetchPolicy: 'network-only'
        } // always get fresh tokens
        ).toPromise();
        const mediaConfig = fetchedData === null || fetchedData === void 0 || (_fetchedData$helpLayo = fetchedData.helpLayout) === null || _fetchedData$helpLayo === void 0 ? void 0 : _fetchedData$helpLayo.mediaConfig;
        if (mediaConfig) return {
            token: mediaConfig.mediaToken,
            baseUrl: mediaConfig.mediaUrl,
            asapIssuer: mediaConfig.asapIssuer
        };
    } catch (err) {
        (0, $jfKi6.sentryQueue).pushError(err);
    }
    return null;
};
const $97b7f48454937b52$var$fetchBatchedMediaConfig = (0, $3qDrS.default)($97b7f48454937b52$var$fetchMediaConfig, 0);
const $97b7f48454937b52$export$71a7df514f18fa5a = (inputAuth, tokenExpiryDuration = $97b7f48454937b52$var$MEDIA_TOKEN_EXPIRY_DURATION_IN_MS)=>{
    const mediaCredentials = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef({
        auth: inputAuth,
        generationTime: Date.now()
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        // reset the token generation time when the token is updated
        mediaCredentials.current = {
            auth: inputAuth,
            generationTime: Date.now()
        };
    // only keeping token string as an dependency to avoid unnecessary update of generationTime
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        inputAuth.token
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(async ()=>{
        return new Promise((resolve)=>{
            if (mediaCredentials.current.generationTime + tokenExpiryDuration > Date.now()) // token is not expired yet
            resolve(mediaCredentials.current.auth);
            else // token is expired
            $97b7f48454937b52$var$fetchBatchedMediaConfig().then((mediaConfig)=>{
                if (mediaConfig) {
                    mediaCredentials.current = {
                        auth: mediaConfig,
                        generationTime: Date.now()
                    };
                    resolve(mediaConfig);
                } else resolve(mediaCredentials.current.auth);
            }).catch(()=>{
                resolve(mediaCredentials.current.auth);
            });
        });
    }, [
        tokenExpiryDuration
    ]);
};

});
parcelRegister("7FKuw", function(module, exports) {
$parcel$export(module.exports, "default", () => $a70b8e333c6c9b31$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8917e4ddcaacd78f560d12aeb2230cd7>>
 * @relayHash dcfa0d470157834356ab5b2a89a0b434
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a431499d34cb929df07363fc6b1ae38c42e0e5e94de697d46d6813fc86b64646
const $a70b8e333c6c9b31$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "mediaToken"
    }, v5 = {
        "kind": "ScalarField",
        "name": "mediaUrl"
    }, v6 = {
        "kind": "ScalarField",
        "name": "asapIssuer"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "helpCenterAuthProviderQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v3 /*: any*/ ,
                                "concreteType": "HelpLayoutMediaConfig",
                                "kind": "LinkedField",
                                "name": "mediaConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v4 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "helpLayout.mediaConfig.mediaToken"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v5 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "helpLayout.mediaConfig.mediaUrl"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v6 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "helpLayout.mediaConfig.asapIssuer"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "helpLayout.mediaConfig"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "helpCenterAuthProviderQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "HelpLayoutMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a431499d34cb929df07363fc6b1ae38c42e0e5e94de697d46d6813fc86b64646",
            "metadata": {},
            "name": "helpCenterAuthProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a70b8e333c6c9b31$var$node.hash = "8d55388dabe06015bee0ae2811adc84a";
var $a70b8e333c6c9b31$export$2e2bcd8739ae039 = $a70b8e333c6c9b31$var$node;

});


parcelRegister("3e2Io", function(module, exports) {
$parcel$export(module.exports, "default", () => $f10fe65532ae872a$export$2e2bcd8739ae039);

var $3En9t = parcelRequire("3En9t");

var $bSJIT = parcelRequire("bSJIT");

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $l5bvm = parcelRequire("l5bvm");

var $lFpPv = parcelRequire("lFpPv");

var $eFyLM = parcelRequire("eFyLM");

var $a2qIF = parcelRequire("a2qIF");

var $6GvED = parcelRequire("6GvED");

var $abU28 = parcelRequire("abU28");

var $ldjCx = parcelRequire("ldjCx");

var $5zxDU = parcelRequire("5zxDU");

var $64ZSD = parcelRequire("64ZSD");

var $35T7J = parcelRequire("35T7J");

var $9BVpB = parcelRequire("9BVpB");

var $4pBHw = parcelRequire("4pBHw");

var $7uUp4 = parcelRequire("7uUp4");

var $2Zepk = parcelRequire("2Zepk");

var $3BUo9 = parcelRequire("3BUo9");
const $f10fe65532ae872a$var$smartCardClient = new (0, $eFyLM.PortalCardClient)();
const $f10fe65532ae872a$var$EditorViewerComponent = ({ editorElement: editorElement, disableAllLinks: disableAllLinks, editorExtensions: editorExtensions, fabricEmojiUrl: fabricEmojiUrl })=>{
    const data = (0, $a2qIF.useFragment)((0, $3En9t.default), editorElement);
    const { adf: adf } = data;
    const { mediaCollectionName: mediaCollectionName, mediaToken: mediaToken, mediaUrl: mediaUrl, asapIssuer: asapIssuer } = data.elementType.mediaConfig;
    const authProvider = (0, $3BUo9.useGetValidHelpCenterAuthProvider)({
        asapIssuer: asapIssuer,
        token: mediaToken,
        baseUrl: mediaUrl
    }); // TODO: get expiry duration via graphql
    const mediaProvider = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>({
            uploadParams: {
                collection: mediaCollectionName
            },
            viewMediaClientConfig: {
                authProvider: authProvider,
                useSha256ForUploads: true
            }
        }), [
        authProvider,
        mediaCollectionName
    ]);
    const providerFactory = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        return (0, $5zxDU.default).create({
            mediaProvider: Promise.resolve(mediaProvider),
            extensionProvider: editorExtensions && Promise.resolve(new (0, $ldjCx.default)(editorExtensions)),
            emojiProvider: (0, $l5bvm.getEmojiProvider)(true, fabricEmojiUrl)
        });
    }, [
        editorExtensions,
        mediaProvider,
        fabricEmojiUrl
    ]);
    const [rendererKey, setRendererKey] = (0, $bSJIT.useState)('without-editor-extensions');
    (0, $bSJIT.useEffect)(()=>{
        async function setExtensionProvider() {
            const extensions = await editorExtensions;
            if (extensions && extensions.length > 0 && providerFactory) {
                providerFactory.removeProvider('extensionProvider');
                providerFactory.setProvider('extensionProvider', Promise.resolve(new (0, $ldjCx.default)(extensions)));
            }
        }
        if (editorExtensions) setExtensionProvider().then(()=>{
            setRendererKey('with-editor-extensions');
        }).catch(()=>{
            setRendererKey('editor-extension-error');
        });
    }, [
        editorExtensions,
        providerFactory
    ]);
    const customStyles = [];
    if (disableAllLinks) customStyles.push($f10fe65532ae872a$var$disableRootStyle);
    if ((0, $lFpPv.isUseHelpCenterRefresh)()) customStyles.push($f10fe65532ae872a$var$smallScreenPadding);
    if (typeof adf === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $abU28.ElementRoot), {
        elementWidth: (0, $abU28.ElementWidth).COMPACT,
        customStyles: customStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $35T7J.MediaClientProvider), {
        clientConfig: mediaProvider.viewMediaClientConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $64ZSD.SmartCardProvider), {
        client: $f10fe65532ae872a$var$smartCardClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7uUp4.default), {
        key: rendererKey,
        appearance: 'full-width',
        document: (0, $2Zepk.parseAdf)(adf),
        dataProviders: providerFactory,
        media: {
            allowLinking: true,
            allowCaptions: true
        },
        allowAltTextOnImages: true,
        shouldOpenMediaViewer: true
    }))));
    return null;
};
const $f10fe65532ae872a$var$selector = (0, $BOq7h.createSelector)((0, $6GvED.getFabricEmojiUrl), (fabricEmojiUrl)=>({
        fabricEmojiUrl: fabricEmojiUrl
    }));
var $f10fe65532ae872a$export$2e2bcd8739ae039 = (0, $egQxE.connect)($f10fe65532ae872a$var$selector, {})($f10fe65532ae872a$var$EditorViewerComponent);
const $f10fe65532ae872a$var$disableRootStyle = (0, $9BVpB.xcss)({
    pointerEvents: 'none'
});
const $f10fe65532ae872a$var$smallScreenPadding = (0, $9BVpB.xcss)({
    // @ts-ignore
    [(0, $4pBHw.media).below.sm]: {
        paddingInline: 'space.400'
    }
});

});
parcelRegister("3En9t", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ccfdf15f0fd9f20$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a54a4b8b7f4aec08d7a216d42763ec06>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7ccfdf15f0fd9f20$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "helpCenterAri"
        }
    ],
    "kind": "Fragment",
    "name": "editorViewRendererFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "adf"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "HelpLayoutAtomicElementType",
                "kind": "LinkedField",
                "name": "elementType",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "parentAri",
                                    "variableName": "helpCenterAri"
                                }
                            ],
                            "concreteType": "HelpLayoutMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "mediaCollectionName"
                                    },
                                    "action": "THROW"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "mediaToken"
                                    },
                                    "action": "THROW"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "mediaUrl"
                                    },
                                    "action": "THROW"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "asapIssuer"
                                    },
                                    "action": "THROW"
                                }
                            ]
                        },
                        "action": "THROW"
                    }
                ]
            },
            "action": "THROW"
        }
    ],
    "type": "HelpLayoutEditorElement"
};
$7ccfdf15f0fd9f20$var$node.hash = "7185bbf55e8e3c72d62297a3cc6f9712";
var $7ccfdf15f0fd9f20$export$2e2bcd8739ae039 = $7ccfdf15f0fd9f20$var$node;

});


parcelRegister("lBa45", function(module, exports) {
$parcel$export(module.exports, "HeroElement", () => (parcelRequire("WOjn2")).default);

var $WOjn2 = parcelRequire("WOjn2");

});
parcelRegister("WOjn2", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c94e7b8ec7b0609$export$2e2bcd8739ae039);

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $edKNU = parcelRequire("edKNU");

var $bqyMO = parcelRequire("bqyMO");
const $6c94e7b8ec7b0609$var$selector = (0, $BOq7h.createSelector)((0, $edKNU.getHelpCenterTopBarSplitFlag), (0, $edKNU.getThemeColor), (0, $edKNU.getHelpCenterTitleColor), (0, $edKNU.getHelpCenterBanner), (hasTopBarBeenSplit, themeColor, helpCenterTitleColor, helpCenterBannerUrl)=>({
        hasTopBarBeenSplit: hasTopBarBeenSplit,
        themeColor: themeColor,
        helpCenterTitleColor: helpCenterTitleColor,
        helpCenterBannerUrl: helpCenterBannerUrl
    }));
var $6c94e7b8ec7b0609$export$2e2bcd8739ae039 = (0, $egQxE.connect)($6c94e7b8ec7b0609$var$selector, {})((0, $bqyMO.HeroElement));

});
parcelRegister("bqyMO", function(module, exports) {
$parcel$export(module.exports, "HeroElement", () => $147582fbf2d8a311$export$bfdb282251ec5601);
/* hero-element.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $gWElZ = parcelRequire("gWElZ");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
var $3zY6O = parcelRequire("3zY6O");

var $lFpPv = parcelRequire("lFpPv");

var $9K7mZ = parcelRequire("9K7mZ");

var $a7Tmb = parcelRequire("a7Tmb");

var $a2qIF = parcelRequire("a2qIF");

var $abU28 = parcelRequire("abU28");

var $busvu = parcelRequire("busvu");

var $1DDTY = parcelRequire("1DDTY");

var $2Trol = parcelRequire("2Trol");

var $c3QJe = parcelRequire("c3QJe");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $1qPbZ = parcelRequire("1qPbZ");

var $4WPlN = parcelRequire("4WPlN");

var $hbgJY = parcelRequire("hbgJY");

var $33Um8 = parcelRequire("33Um8");

var $egy8t = parcelRequire("egy8t");

var $kENn8 = parcelRequire("kENn8");

var $9S1nt = parcelRequire("9S1nt");
const $147582fbf2d8a311$export$6ba969052247c298 = $9K7mZ.unitless * 37 + (0, $1DDTY.HEADER_HEIGHT); // 352
const $147582fbf2d8a311$export$21142d3a706805a3 = $9K7mZ.unitless * 37; // 296
const $147582fbf2d8a311$export$e9a06f3ebc8e9a2c = $9K7mZ.unitless * 22; // 176
const $147582fbf2d8a311$var$HeroElementBackground = ({ backgroundColor: backgroundColor, backgroundImageUrl: backgroundImageUrl, hasTopBarBeenSplit: hasTopBarBeenSplit, children: children })=>{
    // Update CSS variable when helpCenterBanner changes
    $bSJIT.useEffect(()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.documentElement.style.setProperty('--hero-banner-bg-image', backgroundImageUrl ? `url(${backgroundImageUrl})` : 'inherit');
    }, [
        backgroundImageUrl
    ]);
    if ((0, $lFpPv.isIncreasedFlexibilityEnabled)()) return /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        testId: 'hero-element-background',
        xcss: hasTopBarBeenSplit ? $147582fbf2d8a311$var$heroElementBackground : $147582fbf2d8a311$var$heroElementBackgroundWithoutTopBarSplit,
        style: {
            backgroundColor: backgroundColor ?? undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            backgroundImage: 'var(--hero-banner-bg-image)'
        }
    }, children);
    return children;
};
const $147582fbf2d8a311$var$HeroElementImpl = ({ heroElement: heroElement, hasTopBarBeenSplit: hasTopBarBeenSplit, themeColor: themeColor, helpCenterTitleColor: helpCenterTitleColor, helpCenterBannerUrl: helpCenterBannerUrl, hideSearch: hideSearch = false, hideTitle: hideTitle = false, showAiSearch: showAiSearch = false })=>{
    var _data$visualConfig;
    // userLanguageTag is not used in this file, but we do need it for update-hero-layout-element.tsx
    /* eslint-disable relay/unused-fields */ const data = (0, $a2qIF.useFragment)((0, $gWElZ.default), heroElement);
    const shouldRenderAiSearch = !hideSearch && showAiSearch;
    const shouldRenderClassicSearch = !hideSearch && !shouldRenderAiSearch;
    let foregroundColor = (_data$visualConfig = data.visualConfig) === null || _data$visualConfig === void 0 ? void 0 : _data$visualConfig.foregroundColor;
    let backgroundColor = undefined;
    let backgroundImageUrl = undefined;
    if ((0, $lFpPv.isIncreasedFlexibilityEnabled)()) {
        var _data$visualConfig2;
        foregroundColor = data.useGlobalSettings ? helpCenterTitleColor : ((_data$visualConfig2 = data.visualConfig) === null || _data$visualConfig2 === void 0 ? void 0 : _data$visualConfig2.foregroundColor) || "var(--ds-text, #172B4D)";
        const visualConfigStyle = (0, $hbgJY.backgroundStyleFromVisualConfig)(data.visualConfig);
        backgroundColor = data.useGlobalSettings ? themeColor : visualConfigStyle.backgroundColor || themeColor;
        backgroundImageUrl = data.useGlobalSettings ? helpCenterBannerUrl : visualConfigStyle.backgroundImage;
    }
    const { cachedBannerUrl: cachedBackgroundUrl, isLoading: isBackgroundImageLoading } = (0, $33Um8.useCachedUrl)(backgroundImageUrl);
    const [isPageInEditMode] = (0, $c3QJe.useIsPageInEditMode)();
    const { homePageTitle: homePageTitle } = data;
    let bannerHeight = (0, $9S1nt.BANNER_HEIGHT);
    const isSmallScreenSize = (0, $2Trol.useMediaQuery)(`(max-width: ${(0, $a7Tmb.sizes).xxsmall}px)`);
    if ((0, $lFpPv.isUseHelpCenterRefresh)()) bannerHeight = hasTopBarBeenSplit ? $147582fbf2d8a311$export$21142d3a706805a3 : $147582fbf2d8a311$export$6ba969052247c298;
    if ((0, $lFpPv.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit) bannerHeight = 300;
    if (hideSearch) bannerHeight = $147582fbf2d8a311$export$e9a06f3ebc8e9a2c;
    let HelpCenterContainerToRender = $147582fbf2d8a311$var$HelpCenterContainer;
    if ((0, $lFpPv.isUseHelpCenterRefresh)()) HelpCenterContainerToRender = hasTopBarBeenSplit ? $147582fbf2d8a311$var$HelpCenterContainerVisualRefresh : $147582fbf2d8a311$var$HelpCenterContainerVisualRefreshWithoutTopBarSplit;
    const titleAlignment = isSmallScreenSize || !shouldRenderClassicSearch || shouldRenderAiSearch ? 'center' : 'left';
    const renderSearchComponent = ()=>/*#__PURE__*/ $bSJIT.createElement((0, $egy8t.Search), {
            disableSearch: isPageInEditMode
        });
    return /*#__PURE__*/ $bSJIT.createElement((0, $abU28.ElementRoot), {
        elementWidth: (0, $abU28.ElementWidth).FULL_WIDTH,
        elementMargins: (0, $busvu.ElementMargins).COMPACT,
        customStyles: shouldRenderAiSearch ? [
            $147582fbf2d8a311$var$aiSearchHeroPadding
        ] : undefined,
        removePadding: true
    }, /*#__PURE__*/ $bSJIT.createElement($147582fbf2d8a311$var$HeroElementBackground, {
        backgroundColor: backgroundColor,
        backgroundImageUrl: cachedBackgroundUrl,
        hasTopBarBeenSplit: hasTopBarBeenSplit
    }, /*#__PURE__*/ $bSJIT.createElement((0, $1qPbZ.default), {
        name: "hero-element-background-image-loader",
        hold: isBackgroundImageLoading
    }), /*#__PURE__*/ $bSJIT.createElement(HelpCenterContainerToRender, {
        style: {
            height: `${bannerHeight}px`
        }
    }, homePageTitle && !hideTitle && /*#__PURE__*/ $bSJIT.createElement($147582fbf2d8a311$var$HelpCenterTitle, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            textAlign: titleAlignment
        },
        titleColor: foregroundColor ?? undefined
    }, homePageTitle), shouldRenderClassicSearch && renderSearchComponent()), shouldRenderAiSearch && /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        xcss: $147582fbf2d8a311$var$aiSearchTriggerContainer
    }, /*#__PURE__*/ $bSJIT.createElement((0, $4WPlN.CSMSupportSiteAiSearchTrigger), null))));
};
const $147582fbf2d8a311$var$HeroElementWithAiSearchHook = (props)=>{
    return /*#__PURE__*/ $bSJIT.createElement($147582fbf2d8a311$var$HeroElementImpl, {
        ...props,
        showAiSearch: (0, $kENn8.useShouldHeroRenderAiSearch)()
    });
};
const $147582fbf2d8a311$export$bfdb282251ec5601 = (props)=>{
    return /*#__PURE__*/ $bSJIT.createElement($147582fbf2d8a311$var$HeroElementWithAiSearchHook, props);
};
const $147582fbf2d8a311$var$heroElementBackground = (0, $9BVpB.xcss)({
    position: 'relative',
    width: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    borderRadius: 'radius.large'
});
const $147582fbf2d8a311$var$heroElementBackgroundWithoutTopBarSplit = (0, $9BVpB.xcss)({
    position: 'relative',
    width: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
});
const $147582fbf2d8a311$var$aiSearchHeroPadding = (0, $9BVpB.xcss)({
    paddingBlockEnd: 'space.400'
});
const $147582fbf2d8a311$var$aiSearchTriggerContainer = (0, $9BVpB.xcss)({
    position: 'absolute',
    bottom: '0',
    left: '50%',
    transform: 'translate(-50%, 50%)'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $147582fbf2d8a311$var$HelpCenterContainer = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _vchhusvi _1bsb1osq _1e0c1txw _2lx21bp4 _1bahesu3 _ca0q1ejb _n3tdoahv _1rquusvi _jkdiuu9g _lcksoahv _syd2oahv",
            __cmplp.className
        ])
    });
});
const $147582fbf2d8a311$var$HelpCenterContainerVisualRefresh = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _vchhusvi _1bsb1osq _u5f3pxbi _19bvpxbi _1e0c1txw _2lx21bp4 _1bah1h6o _1rquusvi _jkdiuu9g _lcksoahv _syd2oahv",
            __cmplp.className
        ])
    });
});
const $147582fbf2d8a311$var$HelpCenterContainerVisualRefreshWithoutTopBarSplit = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _vchhusvi _1bsb1osq _u5f3pxbi _19bvpxbi _1e0c1txw _2lx21bp4 _1bahesu3 _ca0q1ejb _n3tdoahv _1rquusvi _jkdiuu9g _lcksoahv _syd2oahv",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $147582fbf2d8a311$var$HelpCenterTitle = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { titleColor: titleColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $bSJIT.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_62kwd4": (0, $3zY6O.default)(__cmplp.titleColor)
        },
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_1wyb1f4h _k48p18lj _vwz4xy5q _1dyzz5jk _otyru2gc",
            !!__cmplp.titleColor ? "_syaz3tts" : "_syaz1fxt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gWElZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $adef43c7314c2432$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c93b509df667239e927cb175c978d73>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $adef43c7314c2432$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "heroElementFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "useGlobalSettings"
        },
        {
            "kind": "ScalarField",
            "name": "homePageTitle"
        },
        {
            "kind": "ScalarField",
            "name": "userLanguageTag"
        },
        {
            "kind": "ScalarField",
            "name": "showCSMAISearchTrigger"
        },
        {
            "concreteType": "HelpLayoutVisualConfig",
            "kind": "LinkedField",
            "name": "visualConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "foregroundColor"
                },
                {
                    "kind": "ScalarField",
                    "name": "backgroundColor"
                },
                {
                    "kind": "ScalarField",
                    "name": "backgroundType"
                },
                {
                    "concreteType": "HelpLayoutBackgroundImage",
                    "kind": "LinkedField",
                    "name": "backgroundImage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "HelpLayoutHeroElement"
};
$adef43c7314c2432$var$node.hash = "c36bcff509304de2638e2c5648864f07";
var $adef43c7314c2432$export$2e2bcd8739ae039 = $adef43c7314c2432$var$node;

});

parcelRegister("kENn8", function(module, exports) {
$parcel$export(module.exports, "useShouldHeroRenderAiSearch", () => $7d028ff0ad00273b$export$340f1fb2f1b319d7);

var $eMSqH = parcelRequire("eMSqH");
const $7d028ff0ad00273b$export$340f1fb2f1b319d7 = ()=>{
    const widgetConfigContext = (0, $eMSqH.useOptionalAiWidgetConfig)();
    return Boolean(widgetConfigContext && widgetConfigContext.supportWidgetConfig.isEnabled && widgetConfigContext.supportWidgetConfig.widgetPosition === 'CENTER');
};

});

parcelRegister("9S1nt", function(module, exports) {
$parcel$export(module.exports, "BANNER_HEIGHT", () => $f33d863836dde042$export$ed7cc0d417ee89e);
const $f33d863836dde042$export$ed7cc0d417ee89e = 352;

});




parcelRegister("kTPsj", function(module, exports) {
$parcel$export(module.exports, "ConnectElement", () => (parcelRequire("gLRdZ")).ConnectElement);

var $gLRdZ = parcelRequire("gLRdZ");

});
parcelRegister("gLRdZ", function(module, exports) {
$parcel$export(module.exports, "ConnectElement", () => $5a107ae7723728dc$export$65b4e2a5b8eebf56);

var $hM395 = parcelRequire("hM395");

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $eazQ4 = parcelRequire("eazQ4");
var $kPxiY = parcelRequire("kPxiY");

var $lFpPv = parcelRequire("lFpPv");

var $a2qIF = parcelRequire("a2qIF");

var $abU28 = parcelRequire("abU28");

var $c3QJe = parcelRequire("c3QJe");

var $9BVpB = parcelRequire("9BVpB");

var $jBiia = parcelRequire("jBiia");
const $5a107ae7723728dc$var$CONNECT_FRAGMENT_APP_ROOT = 'connect-fragment-app-root';
const $5a107ae7723728dc$export$65b4e2a5b8eebf56 = ({ connectElementRef: connectElementRef })=>{
    const [isPageInEditMode] = (0, $c3QJe.useIsPageInEditMode)();
    const connectElementData = (0, $a2qIF.useFragment)((0, $hM395.default), connectElementRef);
    const { connectElementType: connectElementType, connectElementPage: connectElementPage } = connectElementData;
    const isValidConnectElement = connectElementType && [
        'headerAndSubheaderPanels',
        'footerPanels'
    ].includes(connectElementType);
    $bSJIT.useEffect(()=>{
        if (!isValidConnectElement) (0, $jBiia.trackError)('connect.element.type.invalid', {
            connectElementType: connectElementType
        }, 'Invalid Connect Element Type received');
    }, [
        isValidConnectElement,
        connectElementType
    ]);
    if (connectElementPage === (0, $kPxiY.HELP_CENTER)) {
        if (connectElementType === 'headerAndSubheaderPanels') return /*#__PURE__*/ $bSJIT.createElement((0, $abU28.ElementRoot), {
            removePadding: true,
            removeMargin: (0, $lFpPv.isIncreasedFlexibilityEnabled)(),
            customStyles: [
                $5a107ae7723728dc$var$maxWidthStyle
            ]
        }, /*#__PURE__*/ $bSJIT.createElement($5a107ae7723728dc$var$ConnectWrapper, {
            isPageInEditMode: isPageInEditMode
        }, /*#__PURE__*/ $bSJIT.createElement((0, $eazQ4.ConnectFragment), {
            page: connectElementPage,
            location: "headerPanels",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: $5a107ae7723728dc$var$CONNECT_FRAGMENT_APP_ROOT
        }), /*#__PURE__*/ $bSJIT.createElement((0, $eazQ4.ConnectFragment), {
            page: connectElementPage,
            location: "subheaderPanels",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: $5a107ae7723728dc$var$CONNECT_FRAGMENT_APP_ROOT
        })));
        if (connectElementType === 'footerPanels') return /*#__PURE__*/ $bSJIT.createElement((0, $abU28.ElementRoot), {
            removePadding: true,
            removeMargin: (0, $lFpPv.isIncreasedFlexibilityEnabled)(),
            customStyles: [
                $5a107ae7723728dc$var$maxWidthStyle
            ]
        }, /*#__PURE__*/ $bSJIT.createElement($5a107ae7723728dc$var$ConnectWrapper, {
            isPageInEditMode: isPageInEditMode
        }, /*#__PURE__*/ $bSJIT.createElement((0, $eazQ4.ConnectFragment), {
            page: connectElementPage,
            location: connectElementType,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: $5a107ae7723728dc$var$CONNECT_FRAGMENT_APP_ROOT
        })));
    }
    return null;
};
const $5a107ae7723728dc$var$maxWidthStyle = (0, $9BVpB.xcss)({
    maxWidth: '840px'
});
// This style wrapper here is leveraging `styled-component` and not `@compiled/react` because, it needed to use nested selectors like child selectors
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $5a107ae7723728dc$var$ConnectWrapper = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-n4uh9j-0"
})`margin:auto;padding-left:${"var(--ds-space-600, 48px)"};padding-right:${"var(--ds-space-600, 48px)"};> *{padding-top:${"var(--ds-space-300, 24px)"};}> :first-child{padding-top:${(0, $lFpPv.isIncreasedFlexibilityEnabled)() ? "var(--ds-space-400, 32px)" : "var(--ds-space-300, 24px)"};}> :last-child{padding-bottom:${(0, $lFpPv.isIncreasedFlexibilityEnabled)() ? "var(--ds-space-400, 32px)" : "var(--ds-space-300, 24px)"};}.connect-fragment-app-root{margin-top:0;}${({ isPageInEditMode: isPageInEditMode })=>isPageInEditMode && `pointer-events: none;`}`;

});
parcelRegister("hM395", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0c33851f6c0174d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<53cf880ddc8f870c1790f6e326f9eedd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d0c33851f6c0174d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "connectElementFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "connectElementPage"
        },
        {
            "kind": "ScalarField",
            "name": "connectElementType"
        }
    ],
    "type": "HelpLayoutConnectElement"
};
$d0c33851f6c0174d$var$node.hash = "88a04fa7e931050b52a2fe8d7668fe89";
var $d0c33851f6c0174d$export$2e2bcd8739ae039 = $d0c33851f6c0174d$var$node;

});



parcelRegister("1uKeu", function(module, exports) {
$parcel$export(module.exports, "ForgeElement", () => (parcelRequire("i6hkC")).default);
// The default export of `hocs` is the Redux-connected `ForgeElement`, which
// injects the current portal's `projectId` so portal-page Forge modules send
// the portal resource context with their fetch-extensions request.

var $i6hkC = parcelRequire("i6hkC");

});
parcelRegister("i6hkC", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2bb014ae230c4b1$export$2e2bcd8739ae039);

var $egQxE = parcelRequire("egQxE");

var $1xrTy = parcelRequire("1xrTy");

var $ik9zp = parcelRequire("ik9zp");

var $9hSCK = parcelRequire("9hSCK");
/**
 * Resolves the project id of the portal currently in context (if any) and
 * injects it into `ForgeElement` as the `projectId` prop.
 *
 * On hub portal pages this lets the Forge header/footer modules attach the
 * portal resource context (`{ resourceId, resourceType: 'PROJECT' }`) to the
 * fetch-extensions request, matching the classic (non-hub) portal home page.
 */ const $f2bb014ae230c4b1$var$mapStateToProps = (state)=>{
    const portalId = (0, $1xrTy.getPortalId)(state);
    return {
        projectId: (0, $ik9zp.getProjectId)(state, portalId)
    };
};
var $f2bb014ae230c4b1$export$2e2bcd8739ae039 = (0, $egQxE.connect)($f2bb014ae230c4b1$var$mapStateToProps, {})((0, $9hSCK.ForgeElement));

});
parcelRegister("9hSCK", function(module, exports) {
$parcel$export(module.exports, "ForgeElement", () => $cdccaff8909a472b$export$a6859f000949f6a0);

var $dBwpW = parcelRequire("dBwpW");

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");

var $i7phc = parcelRequire("i7phc");

var $a2qIF = parcelRequire("a2qIF");

var $abU28 = parcelRequire("abU28");

var $hCHt7 = parcelRequire("hCHt7");

var $dlaM3 = parcelRequire("dlaM3");

var $c3QJe = parcelRequire("c3QJe");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $jBiia = parcelRequire("jBiia");
const $cdccaff8909a472b$export$a6859f000949f6a0 = ({ forgeElementRef: forgeElementRef, projectId: projectId })=>{
    const [isPageInEditMode] = (0, $c3QJe.useIsPageInEditMode)();
    const forgeElementData = (0, $a2qIF.useFragment)((0, $dBwpW.default), forgeElementRef);
    const { forgeElementType: forgeElementType, forgeElementPage: forgeElementPage } = forgeElementData;
    const isValidForgeElement = forgeElementType && [
        'HEADER_AND_SUBHEADER',
        'FOOTER'
    ].includes(forgeElementType);
    const propsForForgeModules = $bSJIT.useMemo(()=>({
            // eslint-disable-next-line relay/no-future-added-value
            page: forgeElementPage,
            noWrapper: true,
            // this is to ignore extra spacings done from within the Forge Components
            allowCustomPadding: true,
            // Only portal pages carry a portal resource context (see projectId docs above).
            ...forgeElementPage === (0, $i7phc.FORGE_PORTAL_HOME) ? {
                projectId: projectId
            } : {}
        }), [
        forgeElementPage,
        projectId
    ]);
    $bSJIT.useEffect(()=>{
        if (!isValidForgeElement) (0, $jBiia.trackError)('forge.element.type.invalid', {
            forgeElementType: forgeElementType
        }, 'Invalid Forge Element Type received');
    }, [
        isValidForgeElement,
        forgeElementType
    ]);
    const getForgeElement = $bSJIT.useCallback(()=>{
        if (forgeElementType === 'HEADER_AND_SUBHEADER') return /*#__PURE__*/ $bSJIT.createElement((0, $dlaM3.ForgeHeaderModule), propsForForgeModules);
        if (forgeElementType === 'FOOTER') return /*#__PURE__*/ $bSJIT.createElement((0, $hCHt7.ForgeFooterModule), propsForForgeModules);
        return null;
    }, [
        forgeElementType,
        propsForForgeModules
    ]);
    return isValidForgeElement ? /*#__PURE__*/ $bSJIT.createElement((0, $abU28.ElementRoot), {
        removePadding: true,
        removeMargin: (0, $lFpPv.isIncreasedFlexibilityEnabled)()
    }, /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        xcss: isPageInEditMode ? [
            $cdccaff8909a472b$var$forgeElementEditStyle
        ] : undefined
    }, getForgeElement())) : null;
};
const $cdccaff8909a472b$var$forgeElementEditStyle = (0, $9BVpB.xcss)({
    pointerEvents: 'none'
});

});
parcelRegister("dBwpW", function(module, exports) {
$parcel$export(module.exports, "default", () => $54faa442567977e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e5553bd3f2d0b1540e667b49ee2c25be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $54faa442567977e8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "forgeElementFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "forgeElementType"
        },
        {
            "kind": "ScalarField",
            "name": "forgeElementPage"
        }
    ],
    "type": "HelpLayoutForgeElement"
};
$54faa442567977e8$var$node.hash = "7cbd50b7d297d1d7e5a2129168127d6e";
var $54faa442567977e8$export$2e2bcd8739ae039 = $54faa442567977e8$var$node;

});




parcelRegister("daK6i", function(module, exports) {
$parcel$export(module.exports, "ListOfPortals", () => (parcelRequire("7G2ja")).default);
parcelRequire("7DVDY");
var $7G2ja = parcelRequire("7G2ja");

});
parcelRegister("7DVDY", function(module, exports) {
$parcel$export(module.exports, "ListOfPortals", () => (parcelRequire("7G2ja")).default);

var $7G2ja = parcelRequire("7G2ja");

});
parcelRegister("7G2ja", function(module, exports) {
$parcel$export(module.exports, "default", () => $d43ee3f180d488b8$export$2e2bcd8739ae039);

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $38uh5 = parcelRequire("38uh5");

var $gT3S9 = parcelRequire("gT3S9");
const $d43ee3f180d488b8$var$selector = (0, $BOq7h.createSelector)((0, $38uh5.isCustomizing), (customizing)=>({
        isSidebarOpen: customizing
    }));
var $d43ee3f180d488b8$export$2e2bcd8739ae039 = (0, $egQxE.connect)($d43ee3f180d488b8$var$selector, {})((0, $gT3S9.ListOfPortals));

});
parcelRegister("gT3S9", function(module, exports) {
$parcel$export(module.exports, "ListOfPortals", () => $be06588cd3c0aae0$export$fbb19a41960594f);

var $5tP6y = parcelRequire("5tP6y");

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $c9wRy = parcelRequire("c9wRy");

var $lFpPv = parcelRequire("lFpPv");

var $98sDU = parcelRequire("98sDU");

var $dypvL = parcelRequire("dypvL");

var $lCAV6 = parcelRequire("lCAV6");

var $ciGty = parcelRequire("ciGty");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $abU28 = parcelRequire("abU28");

var $ctlzt = parcelRequire("ctlzt");

var $4qlmX = parcelRequire("4qlmX");

var $c3QJe = parcelRequire("c3QJe");

var $dwOcU = parcelRequire("dwOcU");

var $85rmf = parcelRequire("85rmf");

var $4GWyU = parcelRequire("4GWyU");

var $8yxPv = parcelRequire("8yxPv");

var $hYh8H = parcelRequire("hYh8H");

var $2IITT = parcelRequire("2IITT");

var $9BVpB = parcelRequire("9BVpB");

var $gUpf2 = parcelRequire("gUpf2");

var $hqXu9 = parcelRequire("hqXu9");

var $i9R3Y = parcelRequire("i9R3Y");
const $be06588cd3c0aae0$export$fbb19a41960594f = ({ listOfHelpCenters: listOfHelpCenters, isSidebarOpen: isSidebarOpen })=>{
    var _portals$, _portals$2;
    const [areAllPortalsVisible, setAllPortalsVisibility] = (0, $bSJIT.useState)(false);
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { portals: portals, visualConfig: visualConfig, expandButtonTextColor: expandButtonTextColor } = (0, $a2qIF.useFragment)((0, $5tP6y.default), listOfHelpCenters);
    const toggleExpandedView = ()=>{
        const willCollapse = areAllPortalsVisible;
        setAllPortalsVisibility(!areAllPortalsVisible);
        setTimeout(()=>{
            if (willCollapse) {
                var _getDocument;
                // Move focus to "Show more portals" button
                const showMoreButton = (_getDocument = (0, $c9wRy.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.getElementById('explore-all-projects');
                if (showMoreButton instanceof HTMLElement) showMoreButton.focus();
            } else {
                var _getDocument2;
                // Move focus to the first link in the expanded section
                const expandedSection = (_getDocument2 = (0, $c9wRy.getDocument)()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.getElementById('expanded-portals-section');
                const firstLink = expandedSection === null || expandedSection === void 0 ? void 0 : expandedSection.querySelector('a, [href], button, [tabindex]');
                firstLink === null || firstLink === void 0 || firstLink.focus();
            }
        }, 0);
    };
    const [isPageInEditMode] = (0, $c3QJe.useIsPageInEditMode)();
    const [isPageInPreviewMode] = (0, $c3QJe.useIsPageInPreviewMode)();
    const { featuredPortals: featuredPortals, allOtherPortals: allOtherPortals } = portals.reduce((acc, current)=>{
        if (current) {
            if (current.isFeatured) acc.featuredPortals.push(current);
            else acc.allOtherPortals.push(current);
        }
        return acc;
    }, {
        featuredPortals: [],
        allOtherPortals: []
    });
    if (portals.length === 0 && isPageInEditMode && !isPageInPreviewMode) {
        const message = (0, $lFpPv.isIncreasedFlexibilityEnabled)() ? (0, $hqXu9.default).emptyStatePortalsDescription : (0, $hqXu9.default).emptyStateDescription;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $be06588cd3c0aae0$var$nonDraggableStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $85rmf.default), {
            header: "",
            maxImageWidth: 250,
            description: formatMessage(message, {
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("b", null, chunks)
            }),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ciGty))),
            width: "wide"
        }));
    }
    if (!portals.length) return null;
    const defaultView = featuredPortals.length ? featuredPortals : allOtherPortals.slice(0, 9);
    const expandedView = featuredPortals.length ? allOtherPortals : allOtherPortals.slice(9);
    const remainingCount = portals.length - defaultView.length;
    const titleTextColor = (0, $lFpPv.isIncreasedFlexibilityEnabled)() && (visualConfig === null || visualConfig === void 0 ? void 0 : visualConfig.titleColor) || undefined;
    const themeButtonColor = (0, $lFpPv.isIncreasedFlexibilityEnabled)() && expandButtonTextColor || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
        data: {
            attributes: {
                numberOfDefaultViewPortals: defaultView.length,
                numberOfExpandedViewPortals: portals.length - defaultView.length
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $abU28.ElementRoot), {
        elementWidth: (0, $abU28.ElementWidth).COMPACT
    }, portals.length === 1 && (_portals$ = portals[0]) !== null && _portals$ !== void 0 && _portals$.portalId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: (0, $lFpPv.isIncreasedFlexibilityEnabled)() && $be06588cd3c0aae0$var$singlePortalStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4qlmX.HelpCenterSinglePortal), {
        portalId: +((_portals$2 = portals[0]) === null || _portals$2 === void 0 ? void 0 : _portals$2.portalId),
        requestTypeSuggestion: []
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dypvL.Title), {
        textColor: titleTextColor
    }, featuredPortals.length ? formatMessage((0, $ctlzt.default).featuredPortalsLabel) : formatMessage((0, $ctlzt.default).remainingPortals)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), {
        xcss: $be06588cd3c0aae0$var$defaultViewStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        as: "ul",
        shouldWrap: true,
        alignInline: "center",
        xcss: [
            $be06588cd3c0aae0$var$portalsListStyles,
            isSidebarOpen ? $be06588cd3c0aae0$var$portalsListStylesWhenSideBarOpen : undefined
        ]
    }, defaultView.map((portal)=>{
        if (portal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
            as: "li",
            xcss: $be06588cd3c0aae0$var$portalListItemStyles,
            key: portal === null || portal === void 0 ? void 0 : portal.portalId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $i9R3Y.Portal), {
            portal: portal
        }));
        return null;
    })), portals.length > defaultView.length && !areAllPortalsVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($be06588cd3c0aae0$var$ToggleViewButton, {
        id: "explore-all-projects",
        overrideThemeColor: themeButtonColor,
        onClick: toggleExpandedView,
        appearance: "link",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
            size: "small",
            spacing: "spacious",
            label: "",
            "aria-hidden": true
        }),
        actionSubjectId: "exploreAllProjects",
        "aria-expanded": areAllPortalsVisible,
        "data-testId": 'exploreAllProjects',
        tabIndex: isPageInEditMode || isPageInPreviewMode ? -1 : undefined,
        nonClickable: isPageInEditMode || isPageInPreviewMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        defaultMessage: (0, $ctlzt.default).exploreAll.defaultMessage,
        id: (0, $ctlzt.default).exploreAll.id,
        values: {
            remainingCount: remainingCount
        }
    }))), areAllPortalsVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), {
        id: "expanded-portals-section",
        xcss: $be06588cd3c0aae0$var$expandedViewStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dypvL.Title), {
        textColor: titleTextColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        defaultMessage: (0, $ctlzt.default).remainingProjectsByName.defaultMessage,
        id: (0, $ctlzt.default).remainingProjectsByName.id
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        as: "ul",
        shouldWrap: true,
        alignInline: "center",
        xcss: [
            $be06588cd3c0aae0$var$portalsListStyles,
            isSidebarOpen ? $be06588cd3c0aae0$var$portalsListStylesWhenSideBarOpen : undefined
        ]
    }, expandedView === null || expandedView === void 0 ? void 0 : expandedView.map((portal)=>{
        if (portal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
            as: "li",
            xcss: $be06588cd3c0aae0$var$portalListItemStyles,
            key: portal === null || portal === void 0 ? void 0 : portal.portalId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $i9R3Y.Portal), {
            portal: portal
        }));
        return null;
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($be06588cd3c0aae0$var$ToggleViewButton, {
        id: "collapse-other-projects",
        overrideThemeColor: themeButtonColor,
        onClick: toggleExpandedView,
        appearance: "link",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8yxPv))), {
            size: "small",
            spacing: "spacious",
            label: "",
            "aria-hidden": true
        }),
        actionSubjectId: "collapseOtherProjects",
        "aria-expanded": areAllPortalsVisible,
        "data-testId": 'collapseOtherProjects'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        defaultMessage: (0, $ctlzt.default).collapseOtherProjects.defaultMessage,
        id: (0, $ctlzt.default).collapseOtherProjects.id
    }))))));
};
// @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $be06588cd3c0aae0$var$ToggleViewButton = /*#__PURE__*/ (0, $4v2A7.default)((0, $lCAV6.ThemedButton)).withConfig({
    componentId: "sc-6p25rg-0"
})`&&{${$98sDU.h500};align-self:center;margin-top:${"var(--ds-space-0, 0px)"};padding:${"var(--ds-space-100, 8px)"};pointer-events:${({ nonClickable: nonClickable })=>nonClickable ? 'none' : 'auto'};&:hover{${$98sDU.h500};margin-top:${"var(--ds-space-0, 0px)"};padding:${"var(--ds-space-100, 8px)"};}}`;
// ref cardStyle in src/view/help-center/portal-card/styled.tsx
const $be06588cd3c0aae0$var$portalCardWidth = '336px';
const $be06588cd3c0aae0$var$portalsListStyles = (0, $9BVpB.xcss)({
    paddingInline: 'space.0',
    marginBlock: 'space.0',
    rowGap: 'space.400',
    justifyContent: 'center',
    // @ts-ignore // 2-grid // because use using custom breakpoints
    '@media (min-width: 37.5rem)': {
        columnGap: `calc(100% - ${$be06588cd3c0aae0$var$portalCardWidth} * 2)`
    },
    // @ts-ignore // 3-grid // because use using custom breakpoints
    '@media (min-width: 80rem)': {
        columnGap: `calc((100% - ${$be06588cd3c0aae0$var$portalCardWidth} * 3) / 2)`
    }
});
const $be06588cd3c0aae0$var$portalsListStylesWhenSideBarOpen = (0, $9BVpB.xcss)({
    // @ts-ignore // 2-grid // because use using custom breakpoints
    '@media (min-width: 80rem)': {
        columnGap: `calc(100% - ${$be06588cd3c0aae0$var$portalCardWidth} * 2)`
    },
    // @ts-ignore // 3-grid // because use using custom breakpoints
    '@media (min-width: 102rem)': {
        // ref src/view/common/element-root/element-root.tsx:63
        columnGap: `calc((100% - ${$be06588cd3c0aae0$var$portalCardWidth} * 3) / 2)`
    }
});
const $be06588cd3c0aae0$var$portalListItemStyles = (0, $9BVpB.xcss)({
    marginBlock: 'space.0',
    maxWidth: '264px',
    // @ts-ignore // because use using custom breakpoints
    '@media (min-width: 37.5rem)': {
        maxWidth: $be06588cd3c0aae0$var$portalCardWidth
    }
});
const $be06588cd3c0aae0$var$defaultViewStyles = (0, $9BVpB.xcss)({
    rowGap: 'space.300'
});
const $be06588cd3c0aae0$var$expandedViewStyles = (0, $9BVpB.xcss)({
    rowGap: 'space.300',
    marginTop: 'space.300'
});
const $be06588cd3c0aae0$var$nonDraggableStyles = (0, $9BVpB.xcss)({
    pointerEvents: 'none'
});
const $be06588cd3c0aae0$var$singlePortalStyles = (0, $9BVpB.xcss)({
    //overflow is needed to prevent margin collapse
    overflow: 'auto',
    margin: '0 auto',
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface.raised',
    boxShadow: 'elevation.shadow.raised',
    //This is the sum of loader height and bottom and top spacing
    minHeight: '96px',
    '@media (min-width: 90rem)': {
        width: '904px'
    }
});

});
parcelRegister("5tP6y", function(module, exports) {
$parcel$export(module.exports, "default", () => $70828afde229f89c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c891ab7758c3537c50b8b22994c02068>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $70828afde229f89c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "HelpLayoutPortalCard",
                "kind": "LinkedField",
                "name": "portals",
                "plural": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "portal_HelpCenterPortal"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isFeatured"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "portalId"
                    }
                ]
            },
            "action": "THROW"
        },
        {
            "kind": "ScalarField",
            "name": "expandButtonTextColor"
        },
        {
            "concreteType": "HelpLayoutVisualConfig",
            "kind": "LinkedField",
            "name": "visualConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "titleColor"
                }
            ]
        }
    ],
    "type": "HelpLayoutPortalsListElement"
};
$70828afde229f89c$var$node.hash = "f54a051de0b1e691ac7801678e0fe57d";
var $70828afde229f89c$export$2e2bcd8739ae039 = $70828afde229f89c$var$node;

});

parcelRegister("ciGty", function(module, exports) {
module.exports = new URL("../images/fallback-portals.b0d407a4.svg", import.meta.url).toString();

});

parcelRegister("hqXu9", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee9afcbc5ecd201d$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $ee9afcbc5ecd201d$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    emptyStateDescription: {
        defaultMessage: 'All your portals are hidden from the home page. Select Topics and portals from the avatar menu to manage your portals.',
        description: 'Description message for portals empty state',
        id: 'hc.customization.list-of-portals.empty-state-description'
    },
    emptyStatePortalsDescription: {
        defaultMessage: 'All your portals are hidden from the home page. Select <b>Customize,</b> then <b>Manage topics and portals</b> from the navigation to manage your portals.',
        description: 'Description message for portals empty state',
        id: 'hc.customization.list-of-portals.empty-state-portals-description'
    }
});

});

parcelRegister("i9R3Y", function(module, exports) {
$parcel$export(module.exports, "Portal", () => $a1b356711afa0d67$export$602eac185826482c);

var $kXlgt = parcelRequire("kXlgt");

var $bSJIT = parcelRequire("bSJIT");

var $a2qIF = parcelRequire("a2qIF");

var $ePXqZ = parcelRequire("ePXqZ");

var $c3QJe = parcelRequire("c3QJe");

var $fyqLX = parcelRequire("fyqLX");
const $a1b356711afa0d67$export$602eac185826482c = ({ portal: portal })=>{
    const [isPageInEditMode] = (0, $c3QJe.useIsPageInEditMode)();
    const { name: name, description: description, logo: logo, portalId: portalId } = (0, $a2qIF.useFragment)((0, $kXlgt.default), portal);
    let descriptionToRender = description === null || description === void 0 ? void 0 : description.toString();
    if (isPageInEditMode && !!descriptionToRender) descriptionToRender = (0, $fyqLX.removeHyperlinks)(descriptionToRender);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ePXqZ.PortalCard), {
        portalName: name,
        description: descriptionToRender,
        portalUrl: `/portal/${Number(portalId)}`,
        iconUrl: logo ?? undefined,
        id: Number(portalId)
    });
};

});
parcelRegister("kXlgt", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ccc9b55ff8b5999$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<31e554af26a9bdda088356712a57bd9a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5ccc9b55ff8b5999$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "portal_HelpCenterPortal",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "logo"
        },
        {
            "kind": "ScalarField",
            "name": "portalId"
        }
    ],
    "type": "HelpLayoutPortalCard"
};
$5ccc9b55ff8b5999$var$node.hash = "3799a41c8f97aa60a39e5e30cebbea7b";
var $5ccc9b55ff8b5999$export$2e2bcd8739ae039 = $5ccc9b55ff8b5999$var$node;

});






parcelRegister("fIqDf", function(module, exports) {
$parcel$export(module.exports, "ListOfTopics", () => (parcelRequire("hWq43")).ListOfTopics);
$parcel$export(module.exports, "helpCenterTopicsProductExperience", () => (parcelRequire("b2cxe")).helpCenterTopicsProductExperience);

var $hWq43 = parcelRequire("hWq43");

var $b2cxe = parcelRequire("b2cxe");

});
parcelRegister("hWq43", function(module, exports) {
$parcel$export(module.exports, "ListOfTopics", () => $f1f7afebcd9c2979$export$2c17f974339f051e);
/* list-of-topics.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2dssb = parcelRequire("2dssb");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");

var $dypvL = parcelRequire("dypvL");

var $ZKxVv = parcelRequire("ZKxVv");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $abU28 = parcelRequire("abU28");

var $cXYaI = parcelRequire("cXYaI");

var $c3QJe = parcelRequire("c3QJe");

var $dwOcU = parcelRequire("dwOcU");

var $6WltM = parcelRequire("6WltM");

var $2usNr = parcelRequire("2usNr");

var $85rmf = parcelRequire("85rmf");

var $87QgR = parcelRequire("87QgR");

var $haAAx = parcelRequire("haAAx");

var $f6Ax9 = parcelRequire("f6Ax9");

var $b2cxe = parcelRequire("b2cxe");

var $hTAOH = parcelRequire("hTAOH");

var $gfAPR = parcelRequire("gfAPR");
const $f1f7afebcd9c2979$var$HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const $f1f7afebcd9c2979$var$isHcAdsDropCommit2Enabled = ()=>(0, $87QgR.default).checkGate($f1f7afebcd9c2979$var$HC_ADS_DROP_COMMIT_2);
const $f1f7afebcd9c2979$var$topicsSectionStyles = null;
const $f1f7afebcd9c2979$var$topicsSectionShapeThemeStyles = null;
const $f1f7afebcd9c2979$var$topicsSectionStyles1Column = null;
const $f1f7afebcd9c2979$var$topicsListStyles = null;
const $f1f7afebcd9c2979$var$listItemStyles3Column = null;
const $f1f7afebcd9c2979$var$listItemStyles2Column = null;
const $f1f7afebcd9c2979$var$listItemStyles1Column = null;
const $f1f7afebcd9c2979$var$nonDraggableStyle = null;
const $f1f7afebcd9c2979$export$6755f52784f1b7fc = ({ topicsElement: topicsElement })=>{
    var _data$visualConfig;
    const data = (0, $a2qIF.useFragment)((0, $2dssb.default), topicsElement);
    const intl = (0, $4vLTk.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const [isPageInEditMode] = (0, $c3QJe.useIsPageInEditMode)();
    const [isPageInPreviewMode] = (0, $c3QJe.useIsPageInPreviewMode)();
    const topics = (data === null || data === void 0 ? void 0 : data.topics) || [];
    const visibleTopics = topics.filter((topic)=>{
        var _topic$items;
        return !topic.hidden && ((_topic$items = topic.items) === null || _topic$items === void 0 ? void 0 : _topic$items.length);
    });
    (0, $bSJIT.useEffect)(()=>{
        if (!isPageInEditMode && visibleTopics.length > 0) {
            const event = createAnalyticsEvent({
                analyticsType: (0, $haAAx.UI_EVENT_TYPE),
                action: 'viewed',
                topics_count: visibleTopics.length
            });
            event.fire();
        }
    }, [
        createAnalyticsEvent,
        visibleTopics.length,
        isPageInEditMode
    ]);
    if (visibleTopics.length === 0) {
        if (isPageInEditMode && !isPageInPreviewMode) {
            const message = (0, $lFpPv.isIncreasedFlexibilityEnabled)() ? (0, $hTAOH.default).emptyStateTopicsDescription : (0, $hTAOH.default).emptyStateDescription;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
                className: (0, $9fU1q.default)([
                    "_lcxvglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $85rmf.default), {
                header: "",
                maxImageWidth: 250,
                description: intl.formatMessage(message, {
                    b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("b", null, chunks)
                }),
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ZKxVv))),
                width: "wide"
            }));
        }
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $abU28.ElementRoot), {
        elementWidth: (0, $abU28.ElementWidth).COMPACT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dypvL.Title), {
        textColor: (0, $lFpPv.isIncreasedFlexibilityEnabled)() && ((_data$visualConfig = data.visualConfig) === null || _data$visualConfig === void 0 ? void 0 : _data$visualConfig.titleColor) || undefined
    }, intl.formatMessage((0, $cXYaI.default).topicsSectionLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-testid": "topics-section-container",
        className: (0, $9fU1q.default)([
            "_2rko12b0 _1bsbncxg _18u01wug _2hwx1wug _bfhkhp5a _16qsnosu _1pbykb7n _1k8r1osq _12wk1osq _48z0idpf",
            visibleTopics.length === 1 && "_1bsbncxg _1k8r1osq _12wk2hgv _48z0idpf",
            $f1f7afebcd9c2979$var$isHcAdsDropCommit2Enabled() && "_2rko1mok"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("ul", {
        className: (0, $9fU1q.default)([
            "_2lx2vrvc _1n261g80 _zulpxy5q _1yt4xy5q _vchhusvi _2mzuglyw _1e0c1txw _1bsb1osq"
        ])
    }, visibleTopics.map((topic, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("li", {
            key: topic.topicId,
            className: (0, $9fU1q.default)([
                visibleTopics.length > 2 && "_19pkidpf _vchhusvi _1bsb1osq _1iy81wug _12wk5kws",
                visibleTopics.length === 2 && "_19pkidpf _vchhusvi _1bsb1osq _1iy81wug _12wk5nr0",
                visibleTopics.length === 1 && "_19pkidpf _vchhusvi _1bsb1osq _1iy81wug _12wk1osq"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
            data: {
                attributes: {
                    topicPosition: index + 1
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gfAPR.default), {
            topic: topic
        })))))), !isPageInEditMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f6Ax9.ExperienceSuccess), {
        experience: (0, $b2cxe.helpCenterTopicsProductExperience)
    }));
};
const $f1f7afebcd9c2979$export$2c17f974339f051e = (0, $2usNr.default)({
    component: 'topics'
})($f1f7afebcd9c2979$export$6755f52784f1b7fc);

});
parcelRegister("2dssb", function(module, exports) {
$parcel$export(module.exports, "default", () => $9daf5da0ee8cb55f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<917e1f41b24f6edfd768b41db740d295>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9daf5da0ee8cb55f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "listOfTopicsElementFragment",
    "selections": [
        {
            "concreteType": "HelpLayoutTopic",
            "kind": "LinkedField",
            "name": "topics",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "topicId"
                },
                {
                    "kind": "ScalarField",
                    "name": "hidden"
                },
                {
                    "concreteType": "HelpLayoutTopicItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "topicCardFragment"
                }
            ]
        },
        {
            "concreteType": "HelpLayoutVisualConfig",
            "kind": "LinkedField",
            "name": "visualConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "titleColor"
                }
            ]
        }
    ],
    "type": "HelpLayoutTopicsListElement"
};
$9daf5da0ee8cb55f$var$node.hash = "00ae89e8e25628e5539a71375e02d691";
var $9daf5da0ee8cb55f$export$2e2bcd8739ae039 = $9daf5da0ee8cb55f$var$node;

});

parcelRegister("ZKxVv", function(module, exports) {
module.exports = new URL("../images/fallback-topics.7343ac7d.svg", import.meta.url).toString();

});

parcelRegister("cXYaI", function(module, exports) {
$parcel$export(module.exports, "default", () => $967648d66a51a4f6$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $967648d66a51a4f6$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    topicsSectionLabel: {
        defaultMessage: 'Topics',
        description: 'Label for the Topics section on the Help center',
        id: 'cv.help-center.topics.label'
    },
    allPortalsHidden: {
        defaultMessage: "There\u2019s no help content available here",
        description: 'Bold message when customer do not see any portals on help center landing page',
        id: 'cv.premium-help-center.empty.page.title'
    },
    allPortalsHiddenAction: {
        defaultMessage: 'Try using the search bar to find help articles or request forms. ',
        description: 'Description to guide customer to contact support when not seeing any portals',
        id: 'cv.premium-help-center.empty.page.description'
    }
});

});

parcelRegister("b2cxe", function(module, exports) {
$parcel$export(module.exports, "helpCenterTopicsProductExperience", () => $64fe78c2a28373cc$export$6eb43314c1279f3f);

var $eAZuG = parcelRequire("eAZuG");

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $64fe78c2a28373cc$export$6eb43314c1279f3f = new (0, $1we90.UFOExperience)((0, $eAZuG.helpCenterTopicsProductExperienceId), {
    type: (0, $7r7ey.ExperienceTypes).Load,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("hTAOH", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad73c9a0b5776b8a$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $ad73c9a0b5776b8a$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    emptyStateDescription: {
        defaultMessage: 'All your topics are hidden or none have been created yet. Select Topics and portals from the avatar menu to create and manage topics.',
        description: 'Description message for topics empty state',
        id: 'hc.customization.list-of-topics.empty-state-description'
    },
    emptyStateTopicsDescription: {
        defaultMessage: 'All your topics are hidden or none have been created. Select <b>Customize,</b> then <b>Manage topics and portals</b> from the navigation to create and manage topics.',
        description: 'Description message for topics empty state',
        id: 'hc.customization.list-of-topics.empty-state-topics-description'
    }
});

});

parcelRegister("gfAPR", function(module, exports) {
$parcel$export(module.exports, "default", () => $d877fa91ba311c0d$export$2e2bcd8739ae039);
/* topic.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $7FerZ = parcelRequire("7FerZ");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $2OuWT = parcelRequire("2OuWT");

var $acAb6 = parcelRequire("acAb6");

var $jcRK7 = parcelRequire("jcRK7");

var $8ksMy = parcelRequire("8ksMy");

var $c6H7d = parcelRequire("c6H7d");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $5lMNy = parcelRequire("5lMNy");

var $c3QJe = parcelRequire("c3QJe");

var $dwOcU = parcelRequire("dwOcU");

var $kIbto = parcelRequire("kIbto");

var $87QgR = parcelRequire("87QgR");

var $67YKA = parcelRequire("67YKA");

var $lavtv = parcelRequire("lavtv");

var $haAAx = parcelRequire("haAAx");

var $irUsc = parcelRequire("irUsc");

var $iydAA = parcelRequire("iydAA");

var $3Asfj = parcelRequire("3Asfj");

var $zZCyy = parcelRequire("zZCyy");

var $oORS9 = parcelRequire("oORS9");
const $d877fa91ba311c0d$var$HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const $d877fa91ba311c0d$var$topicNameLinkStyles = null;
const $d877fa91ba311c0d$var$topicNameWithoutLinkStyles = null;
const $d877fa91ba311c0d$var$helpObjectsStyles = null;
const $d877fa91ba311c0d$var$listItemStyles = null;
const $d877fa91ba311c0d$var$containerStyles = null;
const $d877fa91ba311c0d$var$styledHelpObjectStyles = null;
const $d877fa91ba311c0d$var$helpObjectSpacingStyles = null;
const $d877fa91ba311c0d$var$imageContainerStyles = null;
const $d877fa91ba311c0d$var$helpObjectTitleStyles = null;
const $d877fa91ba311c0d$var$showMoreLinkStyles = null;
const $d877fa91ba311c0d$var$topicLinkStyles = null;
const $d877fa91ba311c0d$var$textContentStyles = null;
const $d877fa91ba311c0d$var$showMoreWithoutLinkStyles = null;
const $d877fa91ba311c0d$export$f3c7ddd8e2c178b5 = (props)=>{
    const { topicName: topicName, items: items, topicId: topicId } = (0, $a2qIF.useFragment)((0, $7FerZ.default), props.topic);
    const intl = (0, $4vLTk.default)();
    const [isPageInEditMode] = (0, $c3QJe.useIsPageInEditMode)();
    const MAX_HELP_OBJECTS = 3;
    const allHelpObjects = (0, $bSJIT.useMemo)(()=>items || [], [
        items
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    (0, $bSJIT.useEffect)(()=>{
        !isPageInEditMode && allHelpObjects.forEach((o)=>{
            if (!(o !== null && o !== void 0 && o.title)) {
                if (createAnalyticsEvent) {
                    const analyticsEvent = createAnalyticsEvent({
                        analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                        action: 'invalidHelpObjectFound',
                        actionSubject: 'helpObject'
                    });
                    analyticsEvent.fire();
                }
            }
        });
    }, [
        isPageInEditMode,
        allHelpObjects,
        createAnalyticsEvent
    ]);
    const showMoreCount = allHelpObjects.length - MAX_HELP_OBJECTS;
    const totalArticleCount = (0, $bSJIT.useMemo)(()=>{
        return allHelpObjects.filter((o)=>(o === null || o === void 0 ? void 0 : o.helpObjectType) === 'HelpObjectStoreArticle').length;
    }, [
        allHelpObjects
    ]);
    (0, $bSJIT.useEffect)(()=>{
        createAnalyticsEvent === null || createAnalyticsEvent === void 0 || createAnalyticsEvent({
            topicId: topicId,
            articlesCount: totalArticleCount,
            analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
            action: 'viewed',
            actionSubject: 'helpCenterTopic'
        }).fire();
    }, [
        totalArticleCount,
        createAnalyticsEvent,
        topicId
    ]);
    const getResourceType = (helpObjectType)=>{
        switch(helpObjectType){
            case 'HelpObjectStoreArticle':
                return 'ARTICLE';
            case 'HelpObjectStoreRequestForm':
                return 'REQUEST_FORM';
            case 'HelpObjectStoreChannel':
                return 'CHANNEL';
            default:
                return 'REQUEST_FORM';
        }
    };
    const isHcAdsDropCommit2Enabled = (0, $87QgR.default).checkGate($d877fa91ba311c0d$var$HC_ADS_DROP_COMMIT_2);
    if (allHelpObjects.length) return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
        data: {
            attributes: {
                topicId: topicId,
                articlesCount: totalArticleCount
            }
        }
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m _4t3i1osq _12ml4ghf _dkzuidpf"
        ])
    }, isPageInEditMode ? /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _1wybdlk8 _vwz4gktf _k48p1wq8 _o5721q9c _1bto1l2s _p12f1osq _syaz1fxt _fwth7vkz _1oi81tcg _1g3k1pd9"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _1bto1l2s"
        ])
    }, topicName)) : /*#__PURE__*/ $bSJIT.createElement((0, $c6H7d.default), {
        to: topicId ? `/topic/${topicId}` : '',
        actionSubjectId: 'topicTitle',
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _1wybdlk8 _vwz4gktf _k48p1wq8 _o5721q9c _1bto1l2s _p12f1osq _fwth7vkz _1oi81tcg _1g3k1pd9"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $lavtv.default), {
        content: topicName
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _1bto1l2s"
        ])
    }, topicName))), /*#__PURE__*/ $bSJIT.createElement("ul", {
        className: (0, $9fU1q.default)([
            "_1yt4ze3t _1wyb1crf _vwz47vkz _2mzuglyw _1e0c1txw _2lx21bp4 _1bsb1osq _19pkpxbi _fwthdlk8 _1oi8gktf"
        ])
    }, allHelpObjects.slice(0, MAX_HELP_OBJECTS).map((helpObject, index)=>/*#__PURE__*/ $bSJIT.createElement("li", {
            key: helpObject === null || helpObject === void 0 ? void 0 : helpObject.__id,
            className: (0, $9fU1q.default)([
                "_19pkidpf"
            ])
        }, /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
            data: {
                attributes: {
                    topicId: topicId,
                    displayLink: helpObject.displayLink,
                    entity: helpObject.entityKey,
                    helpObjectPosition: index + 1
                }
            }
        }, helpObject && /*#__PURE__*/ $bSJIT.createElement("div", {
            "data-testid": "help-object-container",
            className: (0, $9fU1q.default)([
                "_vwz41ejb _1e0c1txw _otyr1no3",
                isHcAdsDropCommit2Enabled && "_zulpu2gc _4cvr1h6o"
            ])
        }, helpObject.logo && (isHcAdsDropCommit2Enabled ? /*#__PURE__*/ $bSJIT.createElement((0, $67YKA.default), {
            size: "medium",
            label: "",
            appearance: "gray",
            icon: ()=>/*#__PURE__*/ $bSJIT.createElement((0, $acAb6.default), {
                    src: helpObject.logo ?? undefined,
                    alt: helpObject.title ?? '',
                    inheritWidth: true
                })
        }) : /*#__PURE__*/ $bSJIT.createElement("div", {
            className: (0, $9fU1q.default)([
                "_4t3i1tcg _1bsb1tcg _2hwxu2gc _1o9zidpf"
            ])
        }, /*#__PURE__*/ $bSJIT.createElement((0, $acAb6.default), {
            src: helpObject.logo,
            alt: helpObject.title ?? '',
            inheritWidth: true
        }))), !helpObject.logo && (helpObject === null || helpObject === void 0 ? void 0 : helpObject.helpObjectType) && (isHcAdsDropCommit2Enabled ? /*#__PURE__*/ $bSJIT.createElement((0, $67YKA.default), {
            size: "medium",
            label: "",
            appearance: "gray",
            icon: ()=>/*#__PURE__*/ $bSJIT.createElement((0, $8ksMy.default), {
                    iconUrl: (0, $oORS9.getUpdatedDisplayLink)((helpObject === null || helpObject === void 0 ? void 0 : helpObject.displayLink) || ''),
                    resourceType: getResourceType((helpObject === null || helpObject === void 0 ? void 0 : helpObject.helpObjectType) || ''),
                    size: 'medium'
                })
        }) : /*#__PURE__*/ $bSJIT.createElement("div", {
            className: (0, $9fU1q.default)([
                "_4t3i1tcg _1bsb1tcg _2hwxu2gc _1o9zidpf"
            ])
        }, /*#__PURE__*/ $bSJIT.createElement((0, $8ksMy.default), {
            iconUrl: (0, $oORS9.getUpdatedDisplayLink)((helpObject === null || helpObject === void 0 ? void 0 : helpObject.displayLink) || ''),
            resourceType: getResourceType(helpObject === null || helpObject === void 0 ? void 0 : helpObject.helpObjectType),
            size: 'medium'
        }))), isPageInEditMode ? /*#__PURE__*/ $bSJIT.createElement("div", {
            className: (0, $9fU1q.default)([
                "_1reo15vq _18m915vq _o5721q9c _1bsb1osq _syaz1fxt _1bto1l2s"
            ])
        }, helpObject.title) : /*#__PURE__*/ $bSJIT.createElement((0, $irUsc.default), {
            screenName: (0, $jcRK7.ScreenName).TOPIC_ITEM_HOMEPAGE
        }, /*#__PURE__*/ $bSJIT.createElement((0, $2OuWT.Link), {
            ...(0, $zZCyy.urlRefsAndTarget)({
                isAnExternalResource: (0, $zZCyy.isExternalResource)(helpObject === null || helpObject === void 0 ? void 0 : helpObject.entityKey),
                displayLink: getResourceType((helpObject === null || helpObject === void 0 ? void 0 : helpObject.helpObjectType) || '') === 'ARTICLE' ? (0, $3Asfj.addSourceToUrl)((0, $oORS9.getUpdatedDisplayLink)((helpObject === null || helpObject === void 0 ? void 0 : helpObject.displayLink) || ''), 'topic', (0, $zZCyy.isExternalResource)(helpObject === null || helpObject === void 0 ? void 0 : helpObject.entityKey)) : (0, $oORS9.getUpdatedDisplayLink)((helpObject === null || helpObject === void 0 ? void 0 : helpObject.displayLink) || '')
            }),
            attributes: {
                topicId: topicId,
                displayLink: helpObject.displayLink,
                entity: helpObject.entityKey
            },
            actionSubjectId: "helpObject",
            className: (0, $9fU1q.default)([
                "_1reo15vq _18m915vq"
            ])
        }, /*#__PURE__*/ $bSJIT.createElement((0, $lavtv.default), {
            content: helpObject.title
        }, /*#__PURE__*/ $bSJIT.createElement("div", {
            className: (0, $9fU1q.default)([
                "_1reo15vq _18m915vq _o5721q9c _1bsb1osq _syaz1fxt _1bto1l2s"
            ])
        }, helpObject.title)), /*#__PURE__*/ $bSJIT.createElement((0, $iydAA.FireScreenEventOnMount), null)))))))), showMoreCount > 0 && (isPageInEditMode ? /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_syaz1fxt"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _1bto1l2s"
        ])
    }, intl.formatMessage((0, $5lMNy.default).showMoreText, {
        count: showMoreCount
    }))) : /*#__PURE__*/ $bSJIT.createElement((0, $c6H7d.default), {
        to: topicId ? `/topic/${topicId}` : '',
        actionSubjectId: 'showMoreHelpObjects',
        className: (0, $9fU1q.default)([
            "_19pk1wug"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _1bto1l2s"
        ])
    }, intl.formatMessage((0, $5lMNy.default).showMoreText, {
        count: showMoreCount
    }))))));
    return null;
};
var $d877fa91ba311c0d$export$2e2bcd8739ae039 = (0, $kIbto.default)()($d877fa91ba311c0d$export$f3c7ddd8e2c178b5);

});
parcelRegister("7FerZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $481807acaa7ad5aa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6552b7aa1e03a7b7ab692c7c4c2d8a2a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $481807acaa7ad5aa$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "topicCardFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "topicName"
        },
        {
            "kind": "ScalarField",
            "name": "topicId"
        },
        {
            "concreteType": "HelpLayoutTopicItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "logo"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayLink"
                },
                {
                    "kind": "ScalarField",
                    "name": "entityKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "helpObjectType"
                },
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__id"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "HelpLayoutTopic"
};
$481807acaa7ad5aa$var$node.hash = "a170162f291e4b6022384af02ae41de2";
var $481807acaa7ad5aa$export$2e2bcd8739ae039 = $481807acaa7ad5aa$var$node;

});

parcelRegister("5lMNy", function(module, exports) {
$parcel$export(module.exports, "default", () => $41b96afeb8504c3f$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $41b96afeb8504c3f$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    showMoreText: {
        defaultMessage: 'Show {count, plural, one {# more} other {# more}}',
        description: 'Text to show the count of the other help objects.',
        id: 'cv.help.topics.show.more'
    }
});

});




parcelRegister("aIkvq", function(module, exports) {
$parcel$export(module.exports, "SuggestedRequestForms", () => (parcelRequire("2zquN")).SuggestedRequestForms);

var $2zquN = parcelRequire("2zquN");

});
parcelRegister("2zquN", function(module, exports) {
$parcel$export(module.exports, "SuggestedRequestForms", () => $6bb4f7f019b8184d$export$60d9fcc75da8405f);

var $5IMBB = parcelRequire("5IMBB");

var $bSJIT = parcelRequire("bSJIT");

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $4v2A7 = parcelRequire("4v2A7");

var $acAb6 = parcelRequire("acAb6");

var $lFpPv = parcelRequire("lFpPv");

var $98sDU = parcelRequire("98sDU");

var $7vjot = parcelRequire("7vjot");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $edKNU = parcelRequire("edKNU");

var $aI0YR = parcelRequire("aI0YR");

var $abU28 = parcelRequire("abU28");

var $9iMuS = parcelRequire("9iMuS");

var $aFV7z = parcelRequire("aFV7z");

var $c3QJe = parcelRequire("c3QJe");

var $85rmf = parcelRequire("85rmf");

var $hYh8H = parcelRequire("hYh8H");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $4pBHw = parcelRequire("4pBHw");

var $kscZT = parcelRequire("kscZT");

var $ldHsu = parcelRequire("ldHsu");
const $6bb4f7f019b8184d$var$selector = (0, $BOq7h.createSelector)((0, $aI0YR.isLoggedIn), (0, $edKNU.getHelpCenterTopBarSplitFlag), (isUserLoggedIn, hasTopBarBeenSplit)=>({
        isUserLoggedIn: isUserLoggedIn,
        hasTopBarBeenSplit: hasTopBarBeenSplit
    }));
const $6bb4f7f019b8184d$var$Component = ({ forms: forms, isUserLoggedIn: isUserLoggedIn, hasTopBarBeenSplit: hasTopBarBeenSplit })=>{
    const data = (0, $a2qIF.useFragment)((0, $5IMBB.default), forms);
    const suggestedRequestTypes = data.suggestedRequestTypes;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [isPageInEditMode] = (0, $c3QJe.useIsPageInEditMode)();
    const [isPageInPreviewMode] = (0, $c3QJe.useIsPageInPreviewMode)();
    if (!(suggestedRequestTypes !== null && suggestedRequestTypes !== void 0 && suggestedRequestTypes.length) && isPageInEditMode && !isPageInPreviewMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $6bb4f7f019b8184d$var$nonDraggableStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $85rmf.default), {
        header: "",
        maxImageWidth: 200,
        description: formatMessage((0, $kscZT.default).emptyStateDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($7vjot))),
        width: "wide"
    }));
    if (suggestedRequestTypes !== null && suggestedRequestTypes !== void 0 && suggestedRequestTypes.length) {
        var _data$visualConfig;
        let stackXCSS = $6bb4f7f019b8184d$var$containerStyles;
        if ((0, $lFpPv.isUseHelpCenterRefresh)() && hasTopBarBeenSplit) stackXCSS = $6bb4f7f019b8184d$var$containerStylesVisualRefreshV2;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $abU28.ElementRoot), {
            elementWidth: (0, $abU28.ElementWidth).FULL_WIDTH
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), {
            xcss: stackXCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($6bb4f7f019b8184d$var$Header, {
            textColor: (0, $lFpPv.isIncreasedFlexibilityEnabled)() && ((_data$visualConfig = data.visualConfig) === null || _data$visualConfig === void 0 ? void 0 : _data$visualConfig.titleColor) || undefined
        }, isUserLoggedIn ? formatMessage((0, $9iMuS.default).headerTitle) : formatMessage((0, $9iMuS.default).headerTitleAnon)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), {
            as: "ul",
            xcss: [
                $6bb4f7f019b8184d$var$listStyles,
                (0, $lFpPv.isIncreasedFlexibilityEnabled)() && $6bb4f7f019b8184d$var$listStylesWithIncreasedFlexibility
            ]
        }, suggestedRequestTypes.map((requestForm)=>{
            const Icon = requestForm.iconUrl == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $acAb6.default), {
                src: requestForm.iconUrl,
                alt: ""
            });
            const LinkAndDescription = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ldHsu.RecentFormsListItem), {
                requestForm: requestForm
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
                as: "li",
                xcss: $6bb4f7f019b8184d$var$itemStyles,
                key: `recentRequestSuggestion_${requestForm.id}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aFV7z.IconCardLayout), {
                padding: 0,
                leftIcon: Icon,
                content: LinkAndDescription
            }));
        }))));
    }
    return null;
};
const $6bb4f7f019b8184d$var$listStyles = (0, $9BVpB.xcss)({
    marginTop: 'space.0',
    paddingLeft: 'space.0',
    rowGap: 'space.150',
    listStyleType: 'none'
});
const $6bb4f7f019b8184d$var$listStylesWithIncreasedFlexibility = (0, $9BVpB.xcss)({
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface.raised',
    boxShadow: 'elevation.shadow.raised',
    padding: 'space.300'
});
const $6bb4f7f019b8184d$var$containerStyles = (0, $9BVpB.xcss)({
    rowGap: 'space.200',
    width: '100%',
    maxWidth: '840px',
    marginInline: 'auto',
    boxSizing: 'border-box',
    paddingInline: 'space.600'
});
const $6bb4f7f019b8184d$var$containerStylesVisualRefreshV2 = (0, $9BVpB.xcss)({
    rowGap: 'space.200',
    width: '100%',
    maxWidth: '840px',
    boxSizing: 'border-box',
    [(0, $4pBHw.media).above.sm]: {
        maxWidth: '744px'
    }
});
const $6bb4f7f019b8184d$var$itemStyles = (0, $9BVpB.xcss)({
    wordWrap: 'break-word',
    marginTop: 'space.0'
});
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $6bb4f7f019b8184d$var$Header = /*#__PURE__*/ (0, $4v2A7.default).h2.withConfig({
    componentId: "sc-1n18jaf-0"
})`${$98sDU.h500};color:${({ textColor: textColor })=>textColor};`;
const $6bb4f7f019b8184d$var$nonDraggableStyle = (0, $9BVpB.xcss)({
    pointerEvents: 'none'
});
const $6bb4f7f019b8184d$export$60d9fcc75da8405f = (0, $egQxE.connect)($6bb4f7f019b8184d$var$selector)($6bb4f7f019b8184d$var$Component);

});
parcelRegister("5IMBB", function(module, exports) {
$parcel$export(module.exports, "default", () => $d934b64dc1ffdea8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ecbae6c0d17264530467a80ba82c92d8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d934b64dc1ffdea8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "suggestedRequestForms_HelpLayoutListOfHelpCenterSuggestedRequestFormsAtomicElement",
    "selections": [
        {
            "concreteType": "HelpLayoutRequestForm",
            "kind": "LinkedField",
            "name": "suggestedRequestTypes",
            "plural": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "recentFormsListItem_on_RequestForm"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                }
            ]
        },
        {
            "concreteType": "HelpLayoutVisualConfig",
            "kind": "LinkedField",
            "name": "visualConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "titleColor"
                }
            ]
        }
    ],
    "type": "HelpLayoutSuggestedRequestFormsListElement"
};
$d934b64dc1ffdea8$var$node.hash = "9adc806ca3099844b30ed5f33c8bc772";
var $d934b64dc1ffdea8$export$2e2bcd8739ae039 = $d934b64dc1ffdea8$var$node;

});

parcelRegister("7vjot", function(module, exports) {
module.exports = new URL("../images/fallback-suggested-request-forms.07df40bf.svg", import.meta.url).toString();

});

parcelRegister("kscZT", function(module, exports) {
$parcel$export(module.exports, "default", () => $973819312d27dca4$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $973819312d27dca4$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    emptyStateDescription: {
        defaultMessage: 'When your customers start raising requests, recently used request forms will show up here.',
        description: 'Description message for suggested request forms empty state',
        id: 'hc.customization.suggested-request-forms.empty-state-description'
    }
});

});

parcelRegister("ldHsu", function(module, exports) {
$parcel$export(module.exports, "RecentFormsListItem", () => $8571398fc158536a$export$1155ebf71af69700);
/* recent-forms-list-item.tsx generated by @compiled/babel-plugin v3.0.2 */ /** @jsxRuntime classic */ 
var $7l3HY = parcelRequire("7l3HY");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4v2A7 = parcelRequire("4v2A7");

var $2OuWT = parcelRequire("2OuWT");

var $fU62V = parcelRequire("fU62V");

var $5cKiX = parcelRequire("5cKiX");

var $a2qIF = parcelRequire("a2qIF");

var $iCvmT = parcelRequire("iCvmT");

var $c3QJe = parcelRequire("c3QJe");

var $dwOcU = parcelRequire("dwOcU");

var $87QgR = parcelRequire("87QgR");
const $8571398fc158536a$var$RECENT_FORM_DESCRIPTION_WRAPPING = 'jsdcloud_18837_recent_form_description_wrapping';
const $8571398fc158536a$var$isRecentFormDescriptionWrappingEnabled = ()=>(0, $87QgR.default).checkGate($8571398fc158536a$var$RECENT_FORM_DESCRIPTION_WRAPPING);
const $8571398fc158536a$var$wrappingDescriptionStyles = null;
const $8571398fc158536a$export$1155ebf71af69700 = ({ requestForm: requestForm, isEmbeddedRoute: isEmbeddedRoute })=>{
    const { portalName: portalName, descriptionHtml: descriptionHtml, portalId: portalId, id: id, name: name } = (0, $a2qIF.useFragment)((0, $7l3HY.default), requestForm);
    const [isPageInEditMode] = (0, $c3QJe.useIsPageInEditMode)();
    return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
        data: {
            attributes: {
                id: id
            }
        }
    }, isPageInEditMode || !portalId ? /*#__PURE__*/ $bSJIT.createElement($8571398fc158536a$var$Title, null, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
        ...(0, $iCvmT.default).linkText,
        values: {
            portalName: portalName,
            formName: name
        }
    })) : /*#__PURE__*/ $bSJIT.createElement($8571398fc158536a$var$LinkContainer, null, /*#__PURE__*/ $bSJIT.createElement($8571398fc158536a$var$FormLink, {
        to: `/portal/${portalId}/create/${id}`,
        actionSubjectId: "suggestionRequestType",
        target: isEmbeddedRoute ? '_blank' : undefined
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
        ...(0, $iCvmT.default).linkText,
        values: {
            portalName: portalName,
            formName: name
        }
    }))), descriptionHtml && ($8571398fc158536a$var$isRecentFormDescriptionWrappingEnabled() ? /*#__PURE__*/ $bSJIT.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: descriptionHtml
        },
        className: (0, $9fU1q.default)([
            "_19pk1b66 _19bvv77o _1i4qfg65"
        ])
    }) : /*#__PURE__*/ $bSJIT.createElement($8571398fc158536a$var$Description, {
        dangerouslySetInnerHTML: {
            __html: descriptionHtml
        }
    })));
};
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8571398fc158536a$var$FormLink = /*#__PURE__*/ (0, $4v2A7.default)((0, $2OuWT.Link)).withConfig({
    componentId: "sc-14rcltp-0"
})`color:${(props)=>`var(--ds-link, ${props.theme.color})`};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8571398fc158536a$var$Title = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-14rcltp-1"
})`color:${(props)=>`var(--ds-link, ${props.theme.color})`};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8571398fc158536a$var$Description = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-14rcltp-2"
})`margin-top:${"var(--ds-space-050, 4px)"};padding-left:${"var(--ds-space-025, 2px)"};& p{${$fU62V.clamp};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8571398fc158536a$var$LinkContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-14rcltp-3"
})`padding-left:${"var(--ds-space-025, 2px)"};`;

});
parcelRegister("7l3HY", function(module, exports) {
$parcel$export(module.exports, "default", () => $278e002ffabebb06$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9cd9654d2f9c249abfb575db3a228e9e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $278e002ffabebb06$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "recentFormsListItem_on_RequestForm",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "descriptionHtml"
        },
        {
            "kind": "ScalarField",
            "name": "portalName"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "portalId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "HelpLayoutRequestForm"
};
$278e002ffabebb06$var$node.hash = "b5d8c7e23b6e2eb41dd1dea2dec19c82";
var $278e002ffabebb06$export$2e2bcd8739ae039 = $278e002ffabebb06$var$node;

});




parcelRegister("hzaNv", function(module, exports) {
$parcel$export(module.exports, "ElementErrorBoundary", () => (parcelRequire("i1WMT")).default);

var $i1WMT = parcelRequire("i1WMT");

});
parcelRegister("i1WMT", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f0fe347f6503dd3$export$2e2bcd8739ae039);

var $cXvGn = parcelRequire("cXvGn");

var $bSJIT = parcelRequire("bSJIT");

var $j2vrN = parcelRequire("j2vrN");

var $jcRK7 = parcelRequire("jcRK7");

var $fT4XN = parcelRequire("fT4XN");

var $4tYz0 = parcelRequire("4tYz0");

var $4ZMmh = parcelRequire("4ZMmh");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $h7kyV = parcelRequire("h7kyV");

var $3cWdD = parcelRequire("3cWdD");

var $c3QJe = parcelRequire("c3QJe");

var $W1icn = parcelRequire("W1icn");
var $hZdF8 = parcelRequire("hZdF8");

var $51XYw = parcelRequire("51XYw");

var $6aB5X = parcelRequire("6aB5X");

var $7WRjA = parcelRequire("7WRjA");

var $6u8nu = parcelRequire("6u8nu");
const $9f0fe347f6503dd3$var$elementExperienceStore = new (0, $hZdF8.ExperienceStore)();
const $9f0fe347f6503dd3$var$experienceMapper = (elementIdentifier)=>{
    switch(elementIdentifier){
        case 'EDITOR':
            return (0, $W1icn.Experience).RENDER_EDITOR_ELEMENT;
        case 'HERO':
            return (0, $W1icn.Experience).RENDER_HERO_ELEMENT;
        case 'ANNOUNCEMENT':
            return (0, $W1icn.Experience).RENDER_ANNOUNCEMENT_ELEMENT;
        case 'TOPICS_LIST':
            return (0, $W1icn.Experience).RENDER_TOPICS_LIST_ELEMENT;
        case 'PORTALS_LIST':
            return (0, $W1icn.Experience).RENDER_PORTALS_LIST_ELEMENT;
        case 'SUGGESTED_REQUEST_FORMS_LIST':
            return (0, $W1icn.Experience).RENDER_SUGGESTED_REQUEST_FORMS_LIST_ELEMENT;
        case 'BREADCRUMB':
            return (0, $W1icn.Experience).RENDER_BREADCRUMB_ELEMENT;
        case 'FORGE':
            return (0, $W1icn.Experience).RENDER_FORGE_ELEMENT;
        case 'NO_CONTENT':
            return (0, $W1icn.Experience).RENDER_NO_CONTENT_ELEMENT;
        default:
            return (0, $W1icn.Experience).RENDER_UNKNOWN_ELEMENT;
    }
};
const $9f0fe347f6503dd3$var$ElementErrorBoundary = ({ screenName: screenName, children: children, helpLayoutElement: helpLayoutElement })=>{
    const data = (0, $a2qIF.useFragment)((0, $cXvGn.default), helpLayoutElement);
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [state] = (0, $c3QJe.useLayoutActions)();
    let experience = screenName === (0, $jcRK7.ScreenName).VIEW_HOMEPAGE ? (0, $3cWdD.viewHomepageExperience) : (0, $h7kyV.editHomepageExperience);
    if (state.experience) experience = state.experience;
    let elementIdentifier = '';
    if (data.__typename === 'QueryError') elementIdentifier = data.identifier || 'UNKNOWN';
    else {
        var _elementType;
        // added addition "?" check, because of a bug https://hello.jira.atlassian.cloud/browse/PORTAL-5454
        elementIdentifier = (data === null || data === void 0 || (_elementType = data.elementType) === null || _elementType === void 0 ? void 0 : _elementType.key) || 'UNKNOWN';
    }
    const targetExperience = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef($9f0fe347f6503dd3$var$elementExperienceStore.createNewUFOExperience({
        experience: $9f0fe347f6503dd3$var$experienceMapper(elementIdentifier)
    }));
    (0, $7WRjA.useUFOComponentExperience)(targetExperience.current);
    // Define a list of valid element identifiers
    const validIdentifiers = [
        'EDITOR',
        'HERO',
        'ANNOUNCEMENT',
        'TOPICS_LIST',
        'PORTALS_LIST',
        'SUGGESTED_REQUEST_FORMS_LIST',
        'FORGE',
        'CONNECT',
        'NO_CONTENT',
        'BREADCRUMB'
    ];
    // Default to UNKNOWN if the element type is not recognized
    elementIdentifier = validIdentifiers.includes(elementIdentifier) ? elementIdentifier : 'UNKNOWN';
    // TODO: Remove this check once we have a better way to handle suggested request form errors
    const viewSuggestedRequestFormError = (0, $bSJIT.useMemo)(()=>{
        return screenName === (0, $jcRK7.ScreenName).VIEW_HOMEPAGE && elementIdentifier === 'SUGGESTED_REQUEST_FORMS_LIST';
    }, [
        elementIdentifier,
        screenName
    ]);
    const rethrowError = (0, $bSJIT.useCallback)((error)=>{
        throw error;
    }, []);
    const traceId = state.traceId;
    const markElementExperienceFailed = (0, $bSJIT.useCallback)((elementExperience, error)=>{
        if (!(0, $51XYw.isFetchNetworkOrClientError)(error)) elementExperience.failure({
            metadata: {
                traceId: traceId,
                screenName: state.screenName,
                error: error === null || error === void 0 ? void 0 : error.message,
                statusCode: error === null || error === void 0 ? void 0 : error.status,
                failureEvent: state.screenName
            }
        }).then((0, $4ZMmh.noop)).catch((0, $4ZMmh.noop));
    }, [
        state.screenName,
        traceId
    ]);
    /**
   * If any error happens inside layout viewer/builder
   * 1. It should fail the entire experience - UFO
   * 2. Return null by default
   * 3. Send error payload to sentry and analytics - through ErrorBoundary
   * 4. Pass reason for the failure -UFO
   */ const markExperienceFailed = (0, $bSJIT.useCallback)((error)=>{
        if (!(0, $51XYw.isFetchNetworkOrClientError)(error) && !viewSuggestedRequestFormError) experience.failure({
            metadata: {
                traceId: traceId,
                id: elementIdentifier,
                error: error === null || error === void 0 ? void 0 : error.message,
                statusCode: error === null || error === void 0 ? void 0 : error.status,
                failureEvent: state.screenName
            }
        }).then((0, $4ZMmh.noop)).catch((0, $4ZMmh.noop));
        if (!state.isPageInEditMode) markElementExperienceFailed(targetExperience.current, error);
        if (state.isPageInEditMode) rethrowError(error);
    }, [
        viewSuggestedRequestFormError,
        experience,
        traceId,
        elementIdentifier,
        state.screenName,
        state.isPageInEditMode,
        markElementExperienceFailed,
        rethrowError
    ]);
    const renderError = (0, $bSJIT.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4tYz0.ElementErrorUI), {
            errorMessage: formatMessage((0, $6u8nu.default).errorMessage),
            elementType: elementIdentifier === 'UNKNOWN' ? data.__typename : elementIdentifier
        });
    }, [
        data.__typename,
        elementIdentifier,
        formatMessage
    ]);
    const renderErrorWithFailure = (error)=>{
        if (!(0, $51XYw.isFetchNetworkOrClientError)(error) && !viewSuggestedRequestFormError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j2vrN.ExperienceFailure), {
            location: "element-error-boundary",
            errorMessage: error.message,
            traceId: traceId,
            status: error.status
        }, renderError());
        return renderError();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        packageName: screenName,
        id: elementIdentifier,
        renderError: !state.isPageInEditMode || screenName === (0, $jcRK7.ScreenName).VIEW_HOMEPAGE ? renderErrorWithFailure : undefined,
        onError: markExperienceFailed
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.only(children), !state.isPageInEditMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6aB5X.UfoExperienceSuccess), {
        experience: targetExperience.current,
        config: {
            metadata: {
                screenName: state.screenName
            }
        }
    }) : null);
};
var $9f0fe347f6503dd3$export$2e2bcd8739ae039 = $9f0fe347f6503dd3$var$ElementErrorBoundary;

});
parcelRegister("cXvGn", function(module, exports) {
$parcel$export(module.exports, "default", () => $12773d20025aff26$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3777f6d35190f6a39d625eaab6a70bcf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $12773d20025aff26$var$node = function() {
    var v0 = [
        {
            "concreteType": "HelpLayoutAtomicElementType",
            "kind": "LinkedField",
            "name": "elementType",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "elementErrorBoundaryFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "InlineFragment",
                "selections": v0 /*: any*/ ,
                "type": "HelpLayoutAnnouncementElement"
            },
            {
                "kind": "InlineFragment",
                "selections": v0 /*: any*/ ,
                "type": "HelpLayoutEditorElement"
            },
            {
                "kind": "InlineFragment",
                "selections": v0 /*: any*/ ,
                "type": "HelpLayoutHeroElement"
            },
            {
                "kind": "InlineFragment",
                "selections": v0 /*: any*/ ,
                "type": "HelpLayoutPortalsListElement"
            },
            {
                "kind": "InlineFragment",
                "selections": v0 /*: any*/ ,
                "type": "HelpLayoutTopicsListElement"
            },
            {
                "kind": "InlineFragment",
                "selections": v0 /*: any*/ ,
                "type": "HelpLayoutSuggestedRequestFormsListElement"
            },
            {
                "kind": "InlineFragment",
                "selections": v0 /*: any*/ ,
                "type": "HelpLayoutBreadcrumbElement"
            },
            {
                "kind": "InlineFragment",
                "selections": v0 /*: any*/ ,
                "type": "HelpLayoutNoContentElement"
            },
            {
                "kind": "InlineFragment",
                "selections": v0 /*: any*/ ,
                "type": "HelpLayoutForgeElement"
            },
            {
                "kind": "InlineFragment",
                "selections": v0 /*: any*/ ,
                "type": "HelpLayoutConnectElement"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "identifier"
                    }
                ],
                "type": "QueryError"
            }
        ],
        "type": "HelpLayoutElement",
        "abstractKey": "__isHelpLayoutElement"
    };
}();
$12773d20025aff26$var$node.hash = "63c7367ce453c0ec7e326e278ee1c41c";
var $12773d20025aff26$export$2e2bcd8739ae039 = $12773d20025aff26$var$node;

});

parcelRegister("4tYz0", function(module, exports) {
$parcel$export(module.exports, "ElementErrorUI", () => $b56491215a01ac7a$export$26cc98774e7f85a9);

var $cVM5r = parcelRequire("cVM5r");

var $cJJTb = parcelRequire("cJJTb");

const $b56491215a01ac7a$export$26cc98774e7f85a9 = (0, $cVM5r.default)({
    loader: (0, $cJJTb.lazyForPaint)(()=>(parcelRequire("f3ETu")), {
        moduleId: "./packages/common-utils/layout-primitives-util/src/element-error-ui/element-error-ui.tsx"
    })
});

});
parcelRegister("f3ETu", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("3sHCB").then(()=>parcelRequire('02brU'));

});


parcelRegister("h7kyV", function(module, exports) {
$parcel$export(module.exports, "editHomepageExperience", () => $dbef3445a727b7b1$export$130f4c6c05ee1043);

var $eAZuG = parcelRequire("eAZuG");

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $dbef3445a727b7b1$export$130f4c6c05ee1043 = new (0, $1we90.UFOExperience)((0, $eAZuG.editHomepageExperienceId), {
    type: (0, $7r7ey.ExperienceTypes).Load,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageLoad
});

});

parcelRegister("3cWdD", function(module, exports) {
$parcel$export(module.exports, "viewHomepageExperience", () => $757325f257fc15d9$export$dac7d6f5cb3657a1);

var $eAZuG = parcelRequire("eAZuG");

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $757325f257fc15d9$export$dac7d6f5cb3657a1 = new (0, $1we90.UFOExperience)((0, $eAZuG.viewHomepageExperienceId), {
    type: (0, $7r7ey.ExperienceTypes).Load,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageLoad
});

});

parcelRegister("W1icn", function(module, exports) {
$parcel$export(module.exports, "Experience", () => $1303473e4dbe0a50$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "EXPERIENCE_CONFIGS", () => $1303473e4dbe0a50$export$d54d7a2744fdf647);

var $7r7ey = parcelRequire("7r7ey");
var $1303473e4dbe0a50$export$c90b54e658fc4d7c = /*#__PURE__*/ function(Experience) {
    Experience["RENDER_EDITOR_ELEMENT"] = "EDITOR";
    Experience["RENDER_HERO_ELEMENT"] = "HERO";
    Experience["RENDER_ANNOUNCEMENT_ELEMENT"] = "ANNOUNCEMENT";
    Experience["RENDER_TOPICS_LIST_ELEMENT"] = "TOPICS_LIST";
    Experience["RENDER_PORTALS_LIST_ELEMENT"] = "PORTALS_LIST";
    Experience["RENDER_SUGGESTED_REQUEST_FORMS_LIST_ELEMENT"] = "SUGGESTED_REQUEST_FORMS_LIST";
    Experience["RENDER_FORGE_ELEMENT"] = "FORGE";
    Experience["RENDER_NO_CONTENT_ELEMENT"] = "NO_CONTENT";
    Experience["RENDER_BREADCRUMB_ELEMENT"] = "BREADCRUMB";
    Experience["RENDER_UNKNOWN_ELEMENT"] = "UNKNOWN";
    return Experience;
}({});
const $1303473e4dbe0a50$export$d54d7a2744fdf647 = {
    ["EDITOR"]: {
        experienceId: 'service-management.help-center.element.EDITOR',
        config: {
            type: (0, $7r7ey.ExperienceTypes).Load,
            performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad
        }
    },
    ["HERO"]: {
        experienceId: 'service-management.help-center.element.HERO',
        config: {
            type: (0, $7r7ey.ExperienceTypes).Load,
            performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad
        }
    },
    ["ANNOUNCEMENT"]: {
        experienceId: 'service-management.help-center.element.ANNOUNCEMENT',
        config: {
            type: (0, $7r7ey.ExperienceTypes).Load,
            performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad
        }
    },
    ["TOPICS_LIST"]: {
        experienceId: 'service-management.help-center.element.TOPICS_LIST',
        config: {
            type: (0, $7r7ey.ExperienceTypes).Load,
            performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad
        }
    },
    ["PORTALS_LIST"]: {
        experienceId: 'service-management.help-center.element.PORTALS_LIST',
        config: {
            type: (0, $7r7ey.ExperienceTypes).Load,
            performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad
        }
    },
    ["SUGGESTED_REQUEST_FORMS_LIST"]: {
        experienceId: 'service-management.help-center.element.SUGGESTED_REQUEST_FORMS_LIST',
        config: {
            type: (0, $7r7ey.ExperienceTypes).Load,
            performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad
        }
    },
    ["FORGE"]: {
        experienceId: 'service-management.help-center.element.FORGE',
        config: {
            type: (0, $7r7ey.ExperienceTypes).Load,
            performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad
        }
    },
    ["NO_CONTENT"]: {
        experienceId: 'service-management.help-center.element.NO_CONTENT',
        config: {
            type: (0, $7r7ey.ExperienceTypes).Load,
            performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad
        }
    },
    ["UNKNOWN"]: {
        experienceId: 'service-management.help-center.element.UNKNOWN',
        config: {
            type: (0, $7r7ey.ExperienceTypes).Load,
            performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad
        }
    },
    ["BREADCRUMB"]: {
        experienceId: 'service-management.help-center.element.BREADCRUMB',
        config: {
            type: (0, $7r7ey.ExperienceTypes).Load,
            performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad
        }
    }
};

});

parcelRegister("hZdF8", function(module, exports) {
$parcel$export(module.exports, "ExperienceStore", () => $a00f07d1d52adaf8$export$583266014372757f);

var $1we90 = parcelRequire("1we90");

var $W1icn = parcelRequire("W1icn");
class $a00f07d1d52adaf8$export$583266014372757f {
    constructor(config){
        this.ufoExperiences = new Map();
        this.commonExperienceConfig = config;
    }
    getExperienceConfig(experience) {
        const targetConfig = (0, $W1icn.EXPERIENCE_CONFIGS)[experience];
        if (!targetConfig) return (0, $W1icn.EXPERIENCE_CONFIGS)[(0, $W1icn.Experience).RENDER_UNKNOWN_ELEMENT];
        return targetConfig;
    }
    createNewUFOExperience(experienceOptions) {
        const targetConfig = this.getExperienceConfig(experienceOptions.experience);
        return new (0, $1we90.UFOExperience)(targetConfig.experienceId, {
            ...targetConfig.config,
            ...this.commonExperienceConfig,
            ...experienceOptions.config
        });
    }
    getOrCreateUFOExperience(experienceOptions) {
        const targetConfig = this.getExperienceConfig(experienceOptions.experience);
        if (!this.ufoExperiences.has(targetConfig.experienceId)) this.ufoExperiences.set(targetConfig.experienceId, this.createNewUFOExperience(experienceOptions));
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.ufoExperiences.get(targetConfig.experienceId);
    }
    get(experienceId) {
        return this.ufoExperiences.get(experienceId);
    }
    getAll() {
        return Array.from(this.ufoExperiences.values());
    }
}

});

parcelRegister("6aB5X", function(module, exports) {
$parcel$export(module.exports, "UfoExperienceSuccess", () => $7d5467e41d980bd5$export$d99ac8c5796d83d1);

var $bSJIT = parcelRequire("bSJIT");
const $7d5467e41d980bd5$export$57b1700d72840f8 = ({ experience: experience, config: config })=>{
    (0, $bSJIT.useEffect)(()=>{
        // Since experience failure function is returning a promise, just executing it without waiting for it to resolve
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        experience.failure(config);
    }, [
        config,
        experience
    ]);
    return null;
};
const $7d5467e41d980bd5$export$d99ac8c5796d83d1 = ({ experience: experience, config: config })=>{
    (0, $bSJIT.useLayoutEffect)(()=>{
        // Since experience failure function is returning a promise, just executing it without waiting for it to resolve
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        experience.success(config);
    }, [
        config,
        experience
    ]);
    return null;
};

});

parcelRegister("6u8nu", function(module, exports) {
$parcel$export(module.exports, "default", () => $e07d6399b07db07f$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $e07d6399b07db07f$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    errorMessage: {
        defaultMessage: "We couldn't load this content. Refresh the page and try again.",
        description: 'Error message for when element content fails to load',
        id: 'cv.portal.customization.layout.primitives.element.error-message'
    }
});

});



parcelRegister("9Cywr", function(module, exports) {
$parcel$export(module.exports, "useSectionAndElementId", () => (parcelRequire("i5RGr")).default);

var $i5RGr = parcelRequire("i5RGr");

});
parcelRegister("i5RGr", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb71da2a960cb1f7$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $c3QJe = parcelRequire("c3QJe");
const $bb71da2a960cb1f7$var$useSectionAndElementId = (elementTypeName, sectionId, elementId)=>{
    const [_, { setLayoutId: setLayoutId }] = (0, $c3QJe.useLayoutIds)();
    (0, $bSJIT.useEffect)(()=>{
        if (elementId && sectionId && elementTypeName) setLayoutId(sectionId, elementId, elementTypeName);
    }, [
        sectionId,
        elementTypeName,
        elementId,
        setLayoutId
    ]);
};
var $bb71da2a960cb1f7$export$2e2bcd8739ae039 = $bb71da2a960cb1f7$var$useSectionAndElementId;

});



//# sourceMappingURL=shared.a01b3f11.js.map
